import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { OrderLineVendorComponent } from "../../orders/components/order-line-vendor/order-line-vendor.component";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { v4 as uuidv4 } from "uuid";
import { InventoryOrderLineDetailComponent } from "../inventory-order-line-detail/inventory-order-line-detail.component";
import { InventoryOrderLineShipToComponent } from "../inventory-order-line-ship-to/inventory-order-line-ship-to.component";
import { InventoryOrderLineItemDetailsComponent } from "../inventory-order-line-item-details/inventory-order-line-item-details.component";
import { CommonModule, DatePipe } from "@angular/common";
import { CheckCurrencyMismatchCallingMethod } from "../../../core/models/common/checkCurrencyCallingMethod";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { GetInventoryPurchaseLineDto } from "../../../core/models/inventoryPurchases/getInventoryPurchaseLineDto";
import { SalesOrderLine } from "../../../core/models/orders/saleOrderLine";
import { SaleOrderLineAddressDto } from "../../../core/models/orders/saleOrderLineAddressDto";
import { SalesOrderNotes } from "../../../core/models/orders/salesOrderNotes";
import { StockPhrase } from "../../../core/models/orders/stockPhrase";
import { UpdateSalesOrderLineDto } from "../../../core/models/orders/updateSalesOrderLineDto";
import { Address } from "../../../core/models/shared/address";
import { AddressCountryRegion } from "../../../core/models/shared/countryRegionList";
import { Currency } from "../../../core/models/shared/currencyList";
import { ReleasedProductVariants } from "../../../core/models/shared/releasedProductVariants";
import { ReleasedProduct } from "../../../core/models/shared/releaseProduct";
import { ShippingMethod } from "../../../core/models/shared/shippingMethod";
import { GetUserDto } from "../../../core/models/users/users/getUserDto";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { GetAllVendorsDto } from "../../../core/models/vendor/getAllVendors";
import { AddNewClientService } from "../../../core/services/add-new-client.service";
import { CustomerAccountService } from "../../../core/services/customer-account.service";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderLineItemDetailService } from "../../../core/services/order-line-item-detail.service";
import { OrderLineItemService } from "../../../core/services/order-line-item.service";
import { OrderNotesSidebarService } from "../../../core/services/order-notes-sidebar.service";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import { ProfileFormService } from "../../../core/services/profile-form.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { SharedService } from "../../../core/services/shared.service";
import { StockPhrasesComponent } from "../../../shared/components/stock-phrases/stock-phrases.component";
import { ClientPurpose } from "../../../shared/enums/clientPurpose";
import { EnumCopiedFrom } from "../../../shared/enums/copied-From.enum";
import { UserRole } from "../../../shared/enums/userRoles.enum";
import { UserManagementService } from "../../../core/services/user-management.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../orders/components/order-summary/order-summary.component";
import { InventoryOrderLineVendorComponent } from "../inventory-order-line-vendor/inventory-order-line-vendor.component";
import { SaleOrderItemLine } from "../../../core/models/inventoryPurchases/saleOrderItemLine.dto";
import { PurchaseOrderLine } from "../../../core/models/samplePO/details/purchaseOrderLine";
import { PurchaseOrderHeader } from "../../../core/models/samplePO/details/purchaseOrderHeader";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-template-service-line-form",
  templateUrl: "./template-service-line-form.component.html",
  styleUrls: ["./template-service-line-form.component.scss"],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    StockPhrasesComponent,
    ModalStackerComponent,
    OrderSummaryComponent,
    InventoryOrderLineDetailComponent,
    InventoryOrderLineShipToComponent,
    InventoryOrderLineItemDetailsComponent,
    InventoryOrderLineVendorComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class TemplateServiceLineFormComponent implements OnInit, OnDestroy {
  @Input() isFromCdi = false;
  @Input() isFromCdiLineAdd = false;
  @Input() poNumber = "";
  @Input() cdiRecId = 0;
  @Input() linesVendorNumber = "";
  @Input() createFinishedGoodTemplate = false;
  @Input() index!: number | null;
  createdBy = "";
  createdDate = "";
  modifiedBy = "";
  modifiedDate = "";
  customerLists: Address[] = [];
  displayPosition = false;
  displayPositionDescription = false;
  displayPositionFactory = false;
  position:
    | "center"
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "topleft"
    | "topright"
    | "bottomleft"
    | "bottomright" = "bottomright";
  closable = false;
  displayModal = false;
  saleOrderItemLine: FormGroup;
  stockPhraseForm: FormGroup;
  currencyList: Currency[] = [];
  releasedProductsList: ReleasedProduct[] = [];
  releasedProductsVariantsList: ReleasedProductVariants[] = [];
  shippingProductsList: ShippingMethod[] = [];
  countryRegionList: AddressCountryRegion[] = [];
  vendroAddressBookObject!: GetAllVendorsDto;
  saleOrderId = "";
  orderLineNumber = "";
  sellCurrency = "";
  lineNumber = 0;
  orderItemLineNumber = 1;
  sellCurrencyStatus = false;
  addressObject!: Address;
  headerObject!: PurchaseOrderHeader;
  lineId = 0;
  customerId = "";
  shipDate = "";
  inHandDate = "";
  shippingMethod = "";
  vendorList: GetAllVendorsDto[] = [];
  stockListing: StockPhrase[] = [];
  filerStockListing: StockPhrase[] = [];
  userRoleId = 0;
  importUserRights = true;
  customerCheckbox = true;
  vendorCheckbox = true;
  vendorAccountNumber = "";
  displaySidebar = false;
  poAssignmentStatus = false;
  directDeliveryVendor = "";
  purchaseOrderId = "";
  poAssignment = "";
  flag = "";
  netFieldStatus = true;
  showAddress = true;
  saleOrderLine!: GetInventoryPurchaseLineDto;
  lineStatusD365 = "";
  proposalIdD365 = "";
  customerBillToObject!: { partyNumber: string; accountNumber: string };
  quickEntyFieldStatus = "";
  vendorId = "";
  saleOrderHeaderStatus = "";
  sellRateValueWithIconStatus = false;
  clientShipToAddressDisabled = false;
  vendorNameShipToAddressDisabled = false;
  userBlockedFromEdit = true;
  salesOrderLine: PurchaseOrderLine = {} as PurchaseOrderLine;
  showCommissionsFields = true;
  isEdit = false;
  userObject!: GetUserDto;
  lineCopiedFromInfo = "";
  @Input() viewPoNumber = "";
  orderDisplayModal = false;
  copiedFromSalesOrderId = "";
  showHistory = false;
  saleOrderLineHistory!: SalesOrderLine;
  lineActionResult = "";
  saveToPortal = false;
  onSubmitDone = false;
  selectedLineStatusD365 = "";
  deliverRemainderD365 = 0;
  orderedPurchaseQuantityD365 = 0;
  addSetupIsnetInForeignCurrencyValue = false;
  addSetupNetCurrencyValue = "";
  isLineProposalExist = false;
  workflowId = 0;
  isMelissaValidationIgnore = false;
  isCopiedLineMelissaValidationIgnore = false;
  customerFinancialDimension = "";
  selectedItemNumber = "";
  @Input() orderType = "inventory-purchase";

  @Input() saleOrderModalStatus = false;
  @Output() closeEvent = new EventEmitter();
  @Output() closeModalNoRefresh = new EventEmitter();
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() lineGridRefresh = new EventEmitter<boolean>();
  @Input() isPartiallyInvoicedOrderLines = false;
  @Output() changeDetect = new EventEmitter<boolean>();
  @Input() selectedSaleOrderLine: SaleOrderLineAddressDto[] = [];
  @Input() allSalesOrderLines: SaleOrderLineAddressDto[] = [];
  @Input() lineGroup = "";
  @Input() site = "";
  @Input() warehouse = "";
  @Input() parent!: FormGroup;
  @Input() serviceLineToEdit!: PurchaseOrderLine;
  @Output() linesForTemplate = new EventEmitter<PurchaseOrderLine[]>();
  @Output() editedServiceLine = new EventEmitter<[PurchaseOrderLine]>();
  state: NavigationExtras = {};
  @ViewChild("lineDetail", { static: false })
  lineDetail!: InventoryOrderLineDetailComponent;
  currentSaleOrderLine!: Address;
  @ViewChild("shipTo", { static: false })
  shipTo!: InventoryOrderLineShipToComponent;

  @ViewChild("details", { static: false })
  details!: InventoryOrderLineItemDetailsComponent;

  @ViewChild("stockPhraseDescription", { static: false })
  stockPhraseDescription!: StockPhrasesComponent;

  @ViewChild("stockPhraseFactory", { static: false })
  stockPhraseFactory!: StockPhrasesComponent;

  @ViewChild("vendor", { static: false })
  vendor!: OrderLineVendorComponent;

  ///@Output() sellCurrencyConversionEvent = new EventEmitter<any>();

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input("saleOrderIdFromModal")
  set saleOrderIdFromModal(value: string) {
    this.saleOrderId = value;
  }

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input("orderLineNumberFromModal")
  set orderLineNumberFromModal(value: number) {
    this.orderLineNumber = value.toString();
    if (this.orderLineNumber) {
      this.isEdit = true;
    }
  }

  //@ViewChild('scrollBottom') private scrollBottom!: ElementRef;

  deliveryAddress = [
    {
      id: 1,
      name: "To Header Ship To",
      status: false,
    },
    {
      id: 2,
      name: "To Vendor",
      status: false,
    },
  ];

  formErrors: Record<string, string> = {
    duplicateVendorDirectDelivery: "",
    itemNumberD365: "",
    vendorPoAssignment: "",
    shipDate: "",
    inHandDate: "",
    addressSelectionName: "",
    deliveryNameD365: "",
    size: "",
    color: "",
    config: "",
    style: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    duplicateVendorDirectDelivery: {
      required: "Vendor is required.",
    },
    itemNumberD365: {
      required: "Category is required.",
    },
    vendorPoAssignment: {
      required: "PO Assignment is required.",
    },
    addressSelectionName: {
      required: "Delivery Address is required.",
    },
    countryRegionIdD365: {
      required: "Country is required.",
    },
    shipDate: {
      required: "Ship date is required.",
    },
    inHandDate: {
      required: "In-Hands date is required.",
    },
    deliveryNameD365: {
      maxlength: "Name must be less than 100 characters.",
    },
    color: {
      required: "Color is required.",
    },
    size: {
      required: "Size is required.",
    },
    config: {
      required: "Config is required.",
    },
    Style: {
      required: "Style is required.",
    },
  };
  //EnumStockPhraseType: any;

  constructor(
    private _formBuilder: FormBuilder,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private route: Router,
    private router: ActivatedRoute,
    private _orderLineItem: OrderLineItemService,
    private _samplepoListingService: SamplepoListingService,
    private _addNewClientService: AddNewClientService,
    private _orderLineItemDetailService: OrderLineItemDetailService,
    private _customerAccountService: CustomerAccountService,
    public datepipe: DatePipe,
    public _orderSummaryService: OrderSummaryService,
    public _loginService: UserManagementService,
    public _profileFormService: ProfileFormService,
    private _sharedService: SharedService,
    public _orderNotesSidebarService: OrderNotesSidebarService
  ) {
    this.saleOrderItemLine = this._formBuilder.group({
      vendor: this._formBuilder.group({
        duplicateVendorDirectDelivery: [""],
        vendorDirectDelivery: [""],
        //vendorPoAssignment: ['', Validators.required],
        vendorName: [""],
        vendorAddress: [""],
        vendorPhone: [""],
        vendorEmail: [""],
        vendorFax: [""],
      }),
      shipTo: this._formBuilder.group({
        deliveryAddress: [""],
        attention: [""],
        countryRegionIdD365: ["", Validators.required],
        zipCodeD365: [{ value: "", disabled: true }, Validators.required],
        cityD365: [{ value: "", disabled: true }],
        stateD365: [{ value: "", disabled: true }],
        addressD365: [""],
        streetD365: [""],
        purposeD365: ClientPurpose.Business,
        isPrimaryD365: "1",
        addressBook: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        postBoxD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        districtNameD365: [""],
        shipToEmailAddress: [""],
        addressSelectionName: ["", Validators.required],
        locationD365: [""],
        addressLocationNumber: [0],
        shipToVendorAccountD365: [""],
        shipToVendorAccountNameD365: [""],
        validateAddress: [""],
        addressFormat: [""],
        rSMJNIShipToEmailD365: [""],
        attentionInformationD365: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
        deliveryNameD365: ["", Validators.maxLength(100)],
      }),
      detail: this._formBuilder.group({
        shippingMethod: [""],
        accountNumberD365: [""],
        shipDate: [""],
        inHandDate: [""],
        firm: [false],
      }),
      lines: this._formBuilder.group({
        itemNumberD365: ["", Validators.required],
        externalItemNumberD365: [""],
        orderedPurchaseQuantityD365: [""],
        isnetInForeignCurrencyStatus: [false],
        purchasePriceD365: [0],
        netTotalD365: [0],
        netConversion: [""],
        netConversionTotal: [""],
        priceInTransactionCurrency: [""],
        amountInTransactionCurrency: [""],
        sell: [0],
        sellTotal: [""],
        sellConversion: [""],
        sellConversionTotal: [""],
        commission: [0],
        grossProfit: [0],
        lineDescriptionD365: [""],
        factoryNotes: [""],
        currencyCodeD365: [""],
        rates: [0],
        locationD365: [""],
        attentionInformationD365: [""],
        nickName: [""],
        color: [""],
        size: [""],
        config: [""],
        style: [""],
        lineRecIdD365: [0],
        isTrackable: [true],
        categoryName: [{ value: "", disabled: true }],
        excluded: [false],
        final: [false],
        salesClassificationD365: [""],
      }),
    });

    this.stockPhraseForm = this._formBuilder.group({
      id: [0],
      visibility: ["", Validators.required],
      type: ["", Validators.required],
      customerAccountNumber: [""],
      vendorAccountNumber: [""],
      description: [""],
      notes: [""],
      status: ["none"],
    });

    this.router.params.subscribe(params => {
      this.saleOrderId = params["id"];
      this.orderLineNumber = params["linenumber"];
      if (this.orderLineNumber) {
        this.isEdit = true;
      }
    });

    if (this.route.getCurrentNavigation()?.extras?.state?.["viewPoNumber"]) {
      this.viewPoNumber =
        this.route.getCurrentNavigation()?.extras?.state?.["viewPoNumber"];
    }

    if (this.route.getCurrentNavigation()?.extras?.state?.["isCdi"]) {
      this.isFromCdi =
        this.route.getCurrentNavigation()?.extras?.state?.["isCdi"];
    } else {
      this.isFromCdi = false;
    }

    if (this.route.getCurrentNavigation()?.extras?.state?.["isCdiLineAdd"]) {
      this.isFromCdiLineAdd =
        this.route.getCurrentNavigation()?.extras?.state?.["isCdiLineAdd"];
    } else {
      this.isFromCdiLineAdd = false;
    }

    if (this.route.getCurrentNavigation()?.extras?.state?.["cdiRecId"]) {
      this.cdiRecId =
        this.route.getCurrentNavigation()?.extras?.state?.["cdiRecId"];
    }
    if (
      this.route.getCurrentNavigation()?.extras?.state?.["linesVendorNumber"]
    ) {
      this.linesVendorNumber =
        this.route.getCurrentNavigation()?.extras?.state?.["linesVendorNumber"];
    }
    if (
      this.route.getCurrentNavigation()?.extras?.state?.[
        "isPartiallyInvoicedOrderLines"
      ]
    ) {
      this.isPartiallyInvoicedOrderLines =
        this.route.getCurrentNavigation()?.extras?.state?.[
          "isPartiallyInvoicedOrderLines"
        ];
    }

    if (this.route.getCurrentNavigation()?.extras?.state?.["orderType"]) {
      this.orderType =
        this.route.getCurrentNavigation()?.extras?.state?.["orderType"];
    }

    this.state = {
      state: {
        orderType: this.orderType,
      },
    } as NavigationExtras;

    this.setInventorySalesLogic();
  }

  ngOnInit(): void {
    this._sharedService.getSampleWorkflow().subscribe(id => {
      this.workflowId = id;
    });

    if (
      this.serviceLineToEdit.tempId ||
      this.serviceLineToEdit.id ||
      this.serviceLineToEdit.portalKeyD365
    ) {
      this.getSourcingVendor(this.serviceLineToEdit.vendorIdD365);
      this.orderLineNumber = this.serviceLineToEdit.id.toString();
      //this.patchValueByLineNumber(this.serviceLineToEdit, this.serviceLineToEdit.currencyCodeD365 ?? '');
    }

    this.getUserProfile();
    if (this.saleOrderId) {
      if (this.isFromCdiLineAdd && this.isFromCdi) {
        this.cdiEditCaseDisableFields();
        this.saleOrderItemLine.get(["detail", "inHandDate"])?.enable();
        this.saleOrderItemLine.get(["lines", "itemNumberD365"])?.enable();
      } else if (this.isFromCdi) {
        this.cdiEditCaseDisableFields();
      } else {
        this.disabledVendorDetailAndLineFields();
      }
      this.getCurrencyListData();
      this.getAllReleaseProduct();
      this.getAllVariants();
      //this.patchValueInLineItemDate();
      this.getCountryRegionListData();
      this.getStateOfCollapseAll();
      this.getInventoryPurchaseHeader();
      this.saleOrderItemLine
        .get(["lines", "isnetInForeignCurrencyStatus"])
        ?.disable();
      // this.IsUserBlockedFromEdit();
      // this.checkShowHideFields();
    }
  }

  setInventorySalesLogic() {
    if (this.orderType == "inventory-sales" && !this.orderLineNumber) {
      this.poAssignment = "Default";
      // this.saleOrderItemLine.patchValue({
      //   vendor: {
      //     vendorPoAssignment: 'Default'
      //   }
      // });
    }
  }

  cdiEditCaseDisableFields() {
    this.saleOrderItemLine.get(["vendor", "vendorName"])?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorAddress"])?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorPhone"])?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorEmail"])?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorFax"])?.disable();
    this.saleOrderItemLine
      .get(["vendor", "duplicateVendorDirectDelivery"])
      ?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorPoAssignment"])?.disable();

    this.saleOrderItemLine.get(["lines", "commission"])?.disable();
    this.saleOrderItemLine.get(["lines", "grossProfit"])?.disable();
    this.saleOrderItemLine
      .get(["lines", "isnetInForeignCurrencyStatus"])
      ?.disable();
    // for Ticket 11639
    //this.saleOrderItemLine.get(['lines', 'factoryNotes'])?.disable();
    //this.saleOrderItemLine.get(['lines', 'lineDescriptionD365'])?.disable();
    this.saleOrderItemLine.get(["lines", "itemNumberD365"])?.disable();
    //this.saleOrderItemLine.get(['lines', 'externalItemNumberD365'])?.disable();
    this.saleOrderItemLine.get(["lines", "sell"])?.disable();

    this.saleOrderItemLine.get(["detail", "shippingMethod"])?.disable();
    this.saleOrderItemLine.get(["detail", "accountNumberD365"])?.disable();
    this.saleOrderItemLine.get(["detail", "firm"])?.disable();
    this.saleOrderItemLine.get(["detail", "shipDate"])?.disable();
    this.saleOrderItemLine.get(["detail", "inHandDate"])?.disable();

    this.saleOrderItemLine.get(["shipTo", "addressSelectionName"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "deliveryNameD365"])?.disable();
    this.saleOrderItemLine
      .get(["shipTo", "attentionInformationD365"])
      ?.disable();
    this.saleOrderItemLine.get(["shipTo", "addressD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "countryRegionIdD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "attention"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "locationD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "rSMJNIShipToEmailD365"])?.disable();
    this.saleOrderItemLine
      .get(["shipTo", "shipToVendorAccountNameD365"])
      ?.disable();
    this.saleOrderItemLine.get(["shipTo", "addressFormat"])?.disable();

    this.netFieldStatus = false;
    this.sellRateValueWithIconStatus = false;
    this.clientShipToAddressDisabled = true;
    this.vendorNameShipToAddressDisabled = true;
  }

  logValidationErrors(group: FormGroup = this.saleOrderItemLine): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  // IsUserBlockedFromEdit() {
  //   this._orderLineItem
  //     .IsUserBlockedFromEdit(this.saleOrderId)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.userBlockedFromEdit = res.data;
  //         if (!this.userBlockedFromEdit) {
  //           this.saleOrderItemLine
  //             .get(['lines', 'isnetInForeignCurrencyStatus'])
  //             ?.disable();
  //           this.disabledFormFieldForInvoiced({} as SalesOrderLine);
  //         }
  //       },
  //       error: () => {
  //         this.userBlockedFromEdit = false;
  //         this.disabledFormFieldForInvoiced({} as SalesOrderLine);
  //       }
  //     });
  // }

  patchValueByLineNumber(
    salesOrderLine: GetInventoryPurchaseLineDto,
    sellCurrencyStatus: string
  ) {
    const saleOrderLineList =
      salesOrderLine.purchaseOrderLine as PurchaseOrderLine;
    if (saleOrderLineList) {
      if (saleOrderLineList) {
        this.lineId = saleOrderLineList.id;
        const lineData = saleOrderLineList;
        this.salesOrderLine = lineData;
        if (salesOrderLine.address) {
          this.currentSaleOrderLine = salesOrderLine.address;
        }

        this.patchValueInLineForm(saleOrderLineList, sellCurrencyStatus);

        const categoryName =
          this.releasedProductsList.find(
            x => x.itemNumberD365 == this.salesOrderLine.itemNumberD365
          )?.nameD365 ?? "";

        this.saleOrderItemLine.patchValue({
          lines: {
            categoryName,
            final: this.saleOrderLine.purchaseOrderLine.finalPoD365,
            excluded: this.saleOrderLine.purchaseOrderLine.excludedD365,
          },
        });

        if (this.lineStatusD365?.toLowerCase() === "invoiced") {
          this.disabledFormFieldForInvoiced();
        }

        if (
          this.lineStatusD365?.toLowerCase() === "delivered" &&
          this.saleOrderHeaderStatus?.toLowerCase() === "delivered"
        ) {
          this.disabledEnabledFormFieldForDelivered();
        }

        if (
          saleOrderLineList &&
          !saleOrderLineList?.deliverySelectionD365
            ?.toLowerCase()
            ?.includes("header")
        ) {
          this.patchValueInDeliveryName(
            saleOrderLineList?.deliveryNameD365 || ""
          );
        }
        // if(saleOrderLineList.deliveryNameD365 === "To Vendor")
        // {
        //   this.shipTo.showNameChange(false);
        // }
        // else
        // {
        //   this.shipTo.showNameChange(true);
        // }

        this.getSourcingVendor(saleOrderLineList?.vendorIdD365 || "");
        //this.shipTo.showNameChange();
        if (saleOrderLineList?.requestedShippingDateD365) {
          // const shipDate = saleOrderLineList[0]?.salesOrderLine.shipDateD365;
          // this.shipDate = shipDate;
          const shipDate = new Date(
            saleOrderLineList?.requestedShippingDateD365
          );
          this.shipDate = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
          this.patchValueInLineShipDate(this.shipDate);
        } else {
          this.shipDate = "";
        }
        if (saleOrderLineList?.requestedDeliveryDateD365) {
          // const inHandDate =
          //   saleOrderLineList[0]?.salesOrderLine.inHandDateD365;
          // this.inHandDate = inHandDate;
          const inHandDate = new Date(
            saleOrderLineList?.requestedDeliveryDateD365
          );
          this.inHandDate =
            this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
          this.patchValueInLineHandDate(this.inHandDate);
        } else {
          this.inHandDate = "";
        }
        if (saleOrderLineList?.deliveryModeIdD365) {
          this.shippingMethod = saleOrderLineList?.deliveryModeIdD365;
          this.patchValueInShippingMethod(this.shippingMethod);
        }
        if (lineData.freightAccountNumD365) {
          this.patchValueInAccountNumber(lineData.freightAccountNumD365);
        }
        if (saleOrderLineList?.rsmFirmD365) {
          this.patchValueInFirm(
            saleOrderLineList?.rsmFirmD365?.toLowerCase() === "yes" ||
              saleOrderLineList?.rsmFirmD365?.toLowerCase() === "true"
              ? true
              : false
          );
        }
      }
      if (salesOrderLine?.address) {
        if (
          saleOrderLineList?.deliverySelectionD365
            ?.toLowerCase()
            .includes("one")
        ) {
          this.showAddress = false;
          this.saleOrderItemLine
            .get(["shipTo", "countryRegionIdD365"])
            ?.enable();
          this.saleOrderItemLine.get(["shipTo", "addressD365"])?.enable();
        }

        if (
          !saleOrderLineList?.deliverySelectionD365
            ?.toLowerCase()
            .includes("header")
        ) {
          this.patchValueInLineAddressForm(salesOrderLine?.address);
        }
      }
      this.deliveryAddress[2].status = false;
    }
  }

  patchValueInAccountNumber(accountNumber: string) {
    this.saleOrderItemLine.patchValue({
      detail: {
        accountNumberD365: accountNumber,
      },
    });
  }

  patchValueInLineShipDate(date: string) {
    this.saleOrderItemLine.patchValue({
      detail: {
        shipDate: date,
      },
    });
  }

  patchValueInLineHandDate(date: string) {
    this.saleOrderItemLine.patchValue({
      detail: {
        inHandDate: date,
      },
    });
  }

  applylineDescriptionLengthValidation(event: FocusEvent) {
    const target = event.target as HTMLTextAreaElement;
    if (target.value) {
      this.saleOrderItemLine.patchValue({
        lines: {
          lineDescriptionD365: target.value.substring(0, 2000),
        },
      });
    }
  }

  patchValueInDeliveryName(name: string) {
    this.saleOrderItemLine.patchValue({
      shipTo: {
        deliveryNameD365: name,
      },
    });
  }

  applyfactoryNotesLengthValidation(event: FocusEvent) {
    const target = event.target as HTMLTextAreaElement;
    if (target.value) {
      this.saleOrderItemLine.patchValue({
        lines: {
          factoryNotes: target.value.substring(0, 2000),
        },
      });
    }
  }

  getSourcingVendor(accountNumberOrName: string) {
    this.vendorId = accountNumberOrName;
    this._samplepoListingService
      .getVendorByNameAndAccountNumberFilter(accountNumberOrName)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.vendorList = res?.data as unknown as GetAllVendorsDto[];
          if (this.vendorList && this.vendorList.length > 0) {
            this.vendroAddressBookObject = this.vendorList[0];
            this.patchValueInVendor(this.vendorList[0]);
            this.patchValueInVendorAccount(accountNumberOrName);
            this.patchValueInVendorAddress(
              this.vendorList[0].partyNumber ?? "",
              accountNumberOrName
            );
            this.getVendorObject(this.vendroAddressBookObject);
          }
        },
      });
  }

  patchValueInVendorAddress(partyNumber: string, accountNumber: string) {
    this._samplepoListingService
      .getVendorAddressByPartyNumber(partyNumber, accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const primaryAddress = res.data.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1"
          );
          if (primaryAddress.length > 0) {
            if (primaryAddress[0].addressD365) {
              this.patchValuesInVendorFormAddressField(
                primaryAddress[0].addressD365
              );
            }
          }
        },
      });
  }

  patchValuesInVendorFormAddressField(address: string) {
    this.saleOrderItemLine.patchValue({
      vendor: {
        vendorAddress: address,
      },
    });
  }

  patchValueInVendor(vendorObject: GetAllVendorsDto) {
    this.saleOrderItemLine.patchValue({
      vendor: {
        vendorName: vendorObject.vendorName,
        vendorPhone: vendorObject.phoneNumber,
        vendorEmail: vendorObject.emailAddress,
        vendorFax: vendorObject.fax,
      },
    });
  }

  patchValueInVendorAccount(vendorAccount: string) {
    this.saleOrderItemLine.patchValue({
      vendor: {
        vendorDirectDelivery: vendorAccount,
        duplicateVendorDirectDelivery: vendorAccount,
      },
    });
  }

  patchValueInLineForm(
    salesOrderLineObject: PurchaseOrderLine,
    sellCurrencyStatus: string
  ) {
    // if (
    //   salesOrderLineObject &&
    //   salesOrderLineObject.lineCopiedFrom &&
    //   salesOrderLineObject.lineCopiedFromHeaderId
    // ) {
    //   this.saleOrderLineHistory = salesOrderLineObject;
    //   this.showHistory = true;
    // }
    this.saleOrderItemLine.patchValue({
      vendor: {
        vendorDirectDelivery: salesOrderLineObject.vendorIdD365,
      },
      lines: {
        itemNumberD365: salesOrderLineObject.itemNumberD365 ?? "",
        externalItemNumberD365:
          salesOrderLineObject.externalItemNumberD365 ?? "",
        orderedPurchaseQuantityD365:
          salesOrderLineObject.orderedPurchaseQuantityD365 ?? "",
        purchasePriceD365: salesOrderLineObject.purchasePriceD365 ?? "",
        netTotalD365: salesOrderLineObject.lineAmountD365 ?? "",
        netConversion: salesOrderLineObject.netConversion ?? "",
        netConversionTotal: salesOrderLineObject.netConversionTotal ?? "",
        lineDescriptionD365: salesOrderLineObject.lineDescriptionD365 ?? "",
        factoryNotes: salesOrderLineObject.factoryNotesD365 ?? "",
        currencyCodeD365: salesOrderLineObject.currencyCodeD365 ?? "",
        rates: salesOrderLineObject.rates ?? "",
        lineRecIdD365: salesOrderLineObject.lineRecIdD365 ?? "",
        size: salesOrderLineObject.sizeD365,
        color: salesOrderLineObject.colorD365,
        config: salesOrderLineObject.configD365,
        style: salesOrderLineObject.styleD365,
        amountInTransactionCurrency:
          salesOrderLineObject.amountInTransactionCurrency,
        priceInTransactionCurrency:
          salesOrderLineObject.priceInTransactionCurrency,
      },
    });

    if (
      !salesOrderLineObject?.deliverySelectionD365
        ?.toLowerCase()
        ?.includes("header")
    ) {
      this.saleOrderItemLine.patchValue({
        shipTo: {
          addressLocationNumber: salesOrderLineObject.postalAddressD365,
          deliveryNameD365: salesOrderLineObject.deliveryNameD365,
        },
      });
    }
    this.lineDetail.patchValueInLines(salesOrderLineObject, sellCurrencyStatus);
    this.shipTo.showAddressFieldLineSelection(
      salesOrderLineObject.deliverySelectionD365 || ""
    );
    // this.shipTo.getVendorByName(
    //   salesOrderLineObject.shipToVendorAccountD365 || ''
    // );

    // if (salesOrderLineObject.vendorPoAssignmentD365) {
    //   this.poAssignment = salesOrderLineObject.vendorPoAssignmentD365;
    // }

    this.patchValueInaddressSelection(
      salesOrderLineObject.deliverySelectionD365 || ""
    );
    // this.lineStatusD365 = salesOrderLineObject.lineStatusD365 || '';
    // this.proposalIdD365 = salesOrderLineObject.proposalIdD365 || '';

    // if (
    //   this.lineStatusD365 &&
    //   this.lineStatusD365?.toLowerCase() === 'invoiced'
    // ) {
    //   this.saleOrderItemLine.get(['vendor', 'vendorPoAssignment'])?.disable();
    // }

    // if (
    //   salesOrderLineObject.deliverRemainderD365 !== null &&
    //   salesOrderLineObject.orderedPurchaseQuantityD365 !== null &&
    //   salesOrderLineObject.deliverRemainderD365 >
    //     salesOrderLineObject.orderedPurchaseQuantityD365
    // ) {
    //   this.disabledQuantityField();
    // }
  }

  disabledFormFieldForInvoiced() {
    this.saleOrderItemLine
      .get(["vendor", "duplicateVendorDirectDelivery"])
      ?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorPoAssignment"])?.disable();

    this.saleOrderItemLine.get(["lines", "factoryNotes"])?.disable();
    this.saleOrderItemLine.get(["lines", "itemNumberD365"])?.disable();
    //this.saleOrderItemLine.get(['lines', 'orderedPurchaseQuantityD365'])?.disable();
    this.saleOrderItemLine.get(["lines", "externalItemNumberD365"])?.disable();
    this.saleOrderItemLine.get(["lines", "currencyCodeD365"])?.disable();
    this.saleOrderItemLine
      .get(["lines", "isnetInForeignCurrencyStatus"])
      ?.disable();

    this.saleOrderItemLine.get(["detail", "shippingMethod"])?.disable();
    this.saleOrderItemLine.get(["detail", "accountNumberD365"])?.disable();
    this.saleOrderItemLine.get(["detail", "firm"])?.disable();
    this.saleOrderItemLine.get(["detail", "shipDate"])?.disable();
    this.saleOrderItemLine.get(["detail", "inHandDate"])?.disable();

    this.saleOrderItemLine.get(["shipTo", "addressSelectionName"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "deliveryNameD365"])?.disable();
    this.saleOrderItemLine
      .get(["shipTo", "attentionInformationD365"])
      ?.disable();
    this.saleOrderItemLine.get(["shipTo", "addressD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "countryRegionIdD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "attention"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "locationD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "rSMJNIShipToEmailD365"])?.disable();
    this.saleOrderItemLine
      .get(["shipTo", "shipToVendorAccountNameD365"])
      ?.disable();
    this.saleOrderItemLine.get(["shipTo", "addressFormat"])?.disable();

    // Enable those fields as per the ticket 11279
    this.saleOrderItemLine.get(["lines", "sell"])?.enable();
    this.saleOrderItemLine.get(["lines", "lineDescriptionD365"])?.enable();
    this.sellRateValueWithIconStatus = false; // to make it sell field enable

    this.netFieldStatus = true;
    this.clientShipToAddressDisabled = true;
    this.vendorNameShipToAddressDisabled = true;
  }

  disabledFormFieldForDelivered() {
    this.saleOrderItemLine
      .get(["vendor", "duplicateVendorDirectDelivery"])
      ?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorPoAssignment"])?.disable();
    this.saleOrderItemLine.get(["lines", "factoryNotes"])?.disable();
    this.saleOrderItemLine.get(["lines", "lineDescriptionD365"])?.disable();
    this.saleOrderItemLine.get(["lines", "itemNumberD365"])?.disable();
    this.saleOrderItemLine
      .get(["lines", "orderedPurchaseQuantityD365"])
      ?.disable();
    this.saleOrderItemLine.get(["lines", "externalItemNumberD365"])?.disable();
    this.saleOrderItemLine.get(["lines", "currencyCodeD365"])?.disable();
    this.saleOrderItemLine
      .get(["lines", "isnetInForeignCurrencyStatus"])
      ?.disable();
    this.saleOrderItemLine.get(["lines", "sell"])?.disable();

    this.saleOrderItemLine.get(["detail", "shippingMethod"])?.disable();
    this.saleOrderItemLine.get(["detail", "accountNumberD365"])?.disable();
    this.saleOrderItemLine.get(["detail", "firm"])?.disable();
    this.saleOrderItemLine.get(["detail", "shipDate"])?.disable();
    this.saleOrderItemLine.get(["detail", "inHandDate"])?.disable();

    this.saleOrderItemLine.get(["shipTo", "addressSelectionName"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "deliveryNameD365"])?.disable();
    this.saleOrderItemLine
      .get(["shipTo", "attentionInformationD365"])
      ?.disable();
    this.saleOrderItemLine.get(["shipTo", "addressD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "countryRegionIdD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "attention"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "locationD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "rSMJNIShipToEmailD365"])?.disable();

    this.saleOrderItemLine
      .get(["shipTo", "shipToVendorAccountNameD365"])
      ?.disable();
    this.saleOrderItemLine.get(["shipTo", "addressFormat"])?.disable();
    this.netFieldStatus = true;
    this.sellRateValueWithIconStatus = true;
    this.clientShipToAddressDisabled = true;
    this.vendorNameShipToAddressDisabled = true;
    // if (
    //   salesOrderLineObject.deliverRemainderD365 !== null &&
    //   salesOrderLineObject.orderedPurchaseQuantityD365 !== null &&
    //   salesOrderLineObject.deliverRemainderD365 <
    //     salesOrderLineObject.orderedPurchaseQuantityD365
    // ) {
    //   this.netFieldStatus = false;
    //   this.saleOrderItemLine.get(['lines', 'lineDescriptionD365'])?.enable();
    //   this.saleOrderItemLine.get(['vendor', 'vendorPoAssignment'])?.enable();
    // }
  }

  disabledEnabledFormFieldForDelivered() {
    this.saleOrderItemLine
      .get(["vendor", "duplicateVendorDirectDelivery"])
      ?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorPoAssignment"])?.disable();
    this.saleOrderItemLine.get(["lines", "factoryNotes"])?.disable();
    this.saleOrderItemLine.get(["lines", "itemNumberD365"])?.disable();
    this.saleOrderItemLine
      .get(["lines", "orderedPurchaseQuantityD365"])
      ?.disable();
    this.saleOrderItemLine.get(["lines", "externalItemNumberD365"])?.disable();
    this.saleOrderItemLine.get(["lines", "currencyCodeD365"])?.disable();
    this.saleOrderItemLine
      .get(["lines", "isnetInForeignCurrencyStatus"])
      ?.disable();

    this.saleOrderItemLine.get(["detail", "shippingMethod"])?.disable();
    this.saleOrderItemLine.get(["detail", "accountNumberD365"])?.disable();
    this.saleOrderItemLine.get(["detail", "firm"])?.disable();
    this.saleOrderItemLine.get(["detail", "shipDate"])?.disable();
    this.saleOrderItemLine.get(["detail", "inHandDate"])?.disable();

    this.saleOrderItemLine.get(["shipTo", "addressSelectionName"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "deliveryNameD365"])?.disable();
    this.saleOrderItemLine
      .get(["shipTo", "attentionInformationD365"])
      ?.disable();
    this.saleOrderItemLine.get(["shipTo", "addressD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "countryRegionIdD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "attention"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "locationD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "rSMJNIShipToEmailD365"])?.disable();

    this.saleOrderItemLine
      .get(["shipTo", "shipToVendorAccountNameD365"])
      ?.disable();
    this.saleOrderItemLine.get(["shipTo", "addressFormat"])?.disable();

    // Enable those fields as per the ticket 11279
    this.saleOrderItemLine.get(["lines", "sell"])?.enable();
    this.saleOrderItemLine.get(["lines", "lineDescriptionD365"])?.enable();
    this.sellRateValueWithIconStatus = false; // to make it sell field enable

    this.netFieldStatus = true;

    this.clientShipToAddressDisabled = true;
    this.vendorNameShipToAddressDisabled = true;
  }

  disabledQuantityField() {
    this.saleOrderItemLine
      .get(["lines", "orderedPurchaseQuantityD365"])
      ?.disable();
  }

  patchValueInaddressSelection(addressSelectionName: string) {
    let addressBook = "";
    if (addressSelectionName.toLowerCase().includes("address book")) {
      addressBook = "Client Address Book";
    } else if (addressSelectionName.toLowerCase().includes("header ship")) {
      addressBook = "To Header Ship To";
    } else if (addressSelectionName.toLowerCase().includes("vendor")) {
      addressBook = "To Vendor";
      this.saleOrderItemLine.patchValue({
        shipTo: {
          shipToVendorAccountNameD365:
            this.saleOrderLine?.address?.descriptionD365 ?? "",
          shipToVendorAccountD365:
            this.saleOrderLine?.address?.descriptionD365 ?? "",
          deliveryNameD365: this.saleOrderLine?.address?.descriptionD365 ?? "",
        },
      });
      this.shipTo.shipTo.vendorAccountSeletion =
        this.saleOrderLine?.address?.descriptionD365 ?? "";
      this.shipTo.shipTo.addressBookName =
        this.saleOrderLine?.address?.descriptionD365 ?? "";
      this.shipTo.addressBookName =
        this.saleOrderLine?.address?.descriptionD365 ?? "";
      this.shipTo.vendorAccountSeletion =
        this.saleOrderLine?.address?.descriptionD365 ?? "";
    } else if (addressSelectionName.toLowerCase().includes("one time")) {
      addressBook = "One Time";
    } else if (addressSelectionName.toLowerCase().includes("blank")) {
      addressBook = "One Time Blank";
    } else {
      addressBook = addressSelectionName;
    }
    this.saleOrderItemLine.patchValue({
      shipTo: {
        addressSelectionName: addressBook,
      },
    });

    if (!addressBook?.toLowerCase()?.includes("header")) {
      this.shipTo.enableAttentionandLocationField();
    }
  }

  patchValueInLineAddressForm(salesOrderLineAddressObject: Address) {
    this.saleOrderItemLine.patchValue({
      shipTo: {
        countryRegionIdD365:
          salesOrderLineAddressObject.countryRegionIdD365 === ""
            ? salesOrderLineAddressObject.countryRegionISOCodeD365
            : salesOrderLineAddressObject.countryRegionIdD365,
        zipCodeD365: salesOrderLineAddressObject.zipCodeD365,
        cityD365: salesOrderLineAddressObject.cityD365,
        stateD365: salesOrderLineAddressObject.stateD365,
        streetD365: salesOrderLineAddressObject.streetD365,
        buildingComplimentD365:
          salesOrderLineAddressObject.buildingComplimentD365,
        postBoxD365: salesOrderLineAddressObject.postBoxD365,
        countyD365: salesOrderLineAddressObject.countyD365,
        streetNumberD365: salesOrderLineAddressObject.streetNumberD365,
        districtNameD365: salesOrderLineAddressObject.districtNameD365,
        addressLocationName:
          salesOrderLineAddressObject.addressLocationNameD365,
        addressD365: salesOrderLineAddressObject.addressD365,
        addressLocationNumber: salesOrderLineAddressObject.locationNumberD365,
        deliveryNameD365: salesOrderLineAddressObject.descriptionD365,
      },
    });
  }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  getVendorObject(event: GetAllVendorsDto) {
    this.vendroAddressBookObject = event;
    if (this.vendroAddressBookObject.vendorAccountNumber) {
      this.vendorCheckbox = false;
      this.vendorAccountNumber =
        this.vendroAddressBookObject.vendorAccountNumber;
      this.directDeliveryVendor = this.vendorAccountNumber;
    }

    if (
      (this.saleOrderHeaderStatus?.toLowerCase() !== "delivered" &&
        this.saleOrderHeaderStatus?.toLowerCase() !== "invoiced") ||
      (this.lineStatusD365?.toLowerCase() !== "delivered" &&
        this.lineStatusD365?.toLowerCase() !== "invoiced")
    ) {
      if (
        this.userBlockedFromEdit &&
        !this.isFromCdi &&
        this.lineStatusD365.toLowerCase() !== "delivered"
      ) {
        this.saleOrderItemLine
          .get(["lines", "isnetInForeignCurrencyStatus"])
          ?.enable();
      }
      this.netFieldStatus = false;
      this.lineDetail.enableNetField();
    }
  }

  disabledVendorDetailAndLineFields() {
    this.saleOrderItemLine.get(["vendor", "vendorName"])?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorAddress"])?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorPhone"])?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorEmail"])?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorFax"])?.disable();
    this.saleOrderItemLine.get(["lines", "commission"])?.disable();
    this.saleOrderItemLine.get(["lines", "grossProfit"])?.disable();
  }

  //getVendorAccountField(event: any) {
  // if (event?.target.value != '') {
  //   this.deliveryAddress[2].status = false;
  // } else {
  //   this.deliveryAddress[2].status = true;
  // }
  //}

  patchValueInLineItemDate() {
    const currentDate = new Date().toISOString();
    this.saleOrderItemLine.patchValue({
      detail: {
        shipDate: currentDate,
        inHandDate: currentDate,
      },
    });
  }

  getAllVariants() {
    this._samplepoListingService
      .getAllVariants()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.releasedProductsVariantsList = res.data.filter(
            item => item.poStopped === "No"
          );
        },
      });
  }

  getAllReleaseProduct() {
    this._samplepoListingService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.releasedProductsList = res.data.filter(
            item => item.poStopped === "No"
          );
        },
      });
  }

  getCurrencyListData() {
    this._addNewClientService
      .getCurrencyList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.currencyList = res.data;
        },
      });
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const shippingData = res.data;
          this.shippingProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
          if (this.shippingMethod) {
            this.onShippingMethodSelect(this.shippingMethod);
          }
        },
      });
  }

  redirectToSummary() {
    this.closeEvent.emit();
  }

  // getSaleOrderData() {
  //   if (this.saleOrderId) {
  //     this._loaderService.setLoaderState(true);
  //     this._orderLineItem
  //       .getSaleOrderData(this.saleOrderId)
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: (res) => {
  //           if (res.data) {
  //             this._loaderService.setLoaderState(false);
  //             if (
  //               res.data.salesOrderHeader?.salesOrderHeader
  //                 ?.jniSalesInventoryD365
  //             ) {
  //               this.orderType = 'inventory-sales';
  //               this.setInventorySalesLogic();
  //             } else {
  //               this.orderType = 'all-sales';
  //             }

  //             if (
  //               res.data.salesOrderHeader?.salesOrderHeader?.foreignCurrencyD365
  //             ) {
  //               this.sellCurrency =
  //                 res.data.salesOrderHeader?.salesOrderHeader?.foreignCurrencyD365;
  //             }
  //             if (
  //               res.data.salesOrderHeader?.salesOrderHeader
  //                 ?.foreignCurrencyStatus
  //             ) {
  //               this.sellCurrencyStatus =
  //                 res.data.salesOrderHeader?.salesOrderHeader?.foreignCurrencyStatus;
  //             }
  //             if (
  //               res.data.salesOrderHeader?.salesOrderHeader
  //                 ?.salesOrderStatusD365
  //             ) {
  //               this.saleOrderHeaderStatus =
  //                 res.data.salesOrderHeader?.salesOrderHeader?.salesOrderStatusD365;
  //             }
  //             if (res.data.salesOrderHeader?.salesOrderHeader) {
  //               this.customerId =
  //                 res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365 ||
  //                 '';
  //               if (this.customerId) {
  //                 this.customerCheckbox = false;
  //                 this.getCustomerFinancialDimension(this.customerId);
  //               }
  //             }
  //             if (
  //               res.data.salesOrderHeader?.salesOrderHeader
  //                 ?.approvalStatusD365 == null ||
  //               res.data.salesOrderHeader?.salesOrderHeader
  //                 ?.approvalStatusD365 == '' ||
  //               res.data.salesOrderHeader?.salesOrderHeader?.approvalStatusD365.toLowerCase() ==
  //                 'none'
  //             ) {
  //               this.vendor.poAssignmentStatus();
  //             }

  //             if (
  //               !this.quickEntyFieldStatus?.includes('Copy Header') &&
  //               !this.quickEntyFieldStatus?.includes('Copy Line') &&
  //               !this.quickEntyFieldStatus?.includes('Add Setup') &&
  //               !this.quickEntyFieldStatus?.includes('Misc')
  //             ) {
  //               if (
  //                 res.data.salesOrderHeader?.address &&
  //                 !(
  //                   res.data?.salesOrderHeader?.salesOrderHeader?.addressSelectionD365
  //                     ?.toLowerCase()
  //                     .includes('multi') ||
  //                   res.data?.salesOrderHeader?.salesOrderHeader?.addressSelectionD365
  //                     ?.toLowerCase()
  //                     .includes('tbd')
  //                 )
  //               ) {
  //                 this.addressObject = res.data.salesOrderHeader.address;
  //                 this.shipTo.onDeliveryAddressChange('To Header Ship To');
  //                 this.shipTo.patchFormInHeaderToShip(this.addressObject);
  //                 this.shipTo.patchFormDeliveryAddress('To Header Ship To', '');
  //               } else {
  //                 const addressSelection =
  //                   res.data.salesOrderHeader?.salesOrderHeader
  //                     ?.addressSelectionD365;
  //                 this.shipTo.patchFormDeliveryAddress(
  //                   'To Header Ship To',
  //                   addressSelection || ''
  //                 );
  //               }
  //               if (res.data.salesOrderHeader?.salesOrderHeader) {
  //                 this.headerObject =
  //                   res.data.salesOrderHeader.salesOrderHeader;
  //                 if (
  //                   this.headerObject?.addressSelectionD365
  //                     ?.toLowerCase()
  //                     ?.includes('multi')
  //                 ) {
  //                   this.headerObject.deliveryNameD365 = 'Multiple Drop Ships';
  //                 } else if (
  //                   this.headerObject?.addressSelectionD365
  //                     ?.toLowerCase()
  //                     ?.includes('tbd')
  //                 ) {
  //                   this.headerObject.deliveryNameD365 = 'TBD';
  //                 }
  //                 this.shipTo.patchFormInHeaderToShipAddress(this.headerObject);
  //               }
  //             }

  //             this.getAllShippingMethod();
  //             if (
  //               res.data.salesOrderHeader?.salesOrderHeader
  //                 ?.shippingMethodD365 &&
  //               !this.orderLineNumber
  //             ) {
  //               this.shippingMethod =
  //                 res.data.salesOrderHeader?.salesOrderHeader?.shippingMethodD365;
  //               this.patchValueInShippingMethod(this.shippingMethod);
  //             }
  //             if (res.data.salesOrderLine) {
  //               if (res.data.salesOrderLine.length > 0) {
  //                 this.saleOrderLine = res.data.salesOrderLine;

  //                 if (this.orderLineNumber) {
  //                   const saleOrderLineList = res?.data?.salesOrderLine.filter(
  //                     (x) =>
  //                       x.salesOrderLine?.id === parseInt(this.orderLineNumber)
  //                   );
  //                   if (saleOrderLineList[0]?.salesOrderLine) {
  //                     this.showHideButtons(
  //                       saleOrderLineList[0].salesOrderLine.proposalIdD365
  //                     );
  //                     this.setModDates(saleOrderLineList[0]?.salesOrderLine);
  //                     const number =
  //                       saleOrderLineList[0]?.salesOrderLine?.lineNumberD365;
  //                     this.orderItemLineNumber = number || 1;

  //                     this.selectedItemNumber =
  //                       saleOrderLineList[0].salesOrderLine.itemNumberD365 ||
  //                       '';
  //                   }
  //                 } else {
  //                   this.getLineNumber(this.saleOrderId);
  //                 }
  //                 this.patchValueByLineNumber(
  //                   res.data.salesOrderLine,
  //                   this.sellCurrency
  //                 );
  //               }
  //             }
  //             if (this.saleOrderLine.length > 0 && !this.orderLineNumber) {
  //               this.checkPOAssignment();
  //             }
  //             if (this.sellCurrencyStatus) {
  //               this.lineDetail.getSellCurrency(this.sellCurrency);
  //             }
  //             if (res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365) {
  //               this._orderLineItem
  //                 .getPartyNumberByAccountNumber(
  //                   res.data.salesOrderHeader?.salesOrderHeader.customerIdD365
  //                 )
  //                 .subscribe((x) => {
  //                   this.patchValueInCustomerAddressField(
  //                     res.data.salesOrderHeader?.salesOrderHeader
  //                       ?.customerIdD365 || '',
  //                     x.data || ''
  //                   );
  //                 });
  //             }

  //             if (res?.data?.salesOrderLine) {
  //               if (
  //                 res?.data?.salesOrderLine?.length > 0 &&
  //                 res?.data.salesOrderLine[0]?.salesOrderLine
  //               ) {
  //                 this.selectedLineStatusD365 =
  //                   res.data.salesOrderLine[0].salesOrderLine.lineStatusD365 ??
  //                   '';
  //                 this.orderedPurchaseQuantityD365 =
  //                   res.data.salesOrderLine[0].salesOrderLine
  //                     .orderedPurchaseQuantityD365 ?? 0;
  //                 this.deliverRemainderD365 =
  //                   res.data.salesOrderLine[0].salesOrderLine
  //                     .deliverRemainderD365 ?? 0;
  //                 this.checkShowHideFields();
  //               }
  //             }
  //           } else {
  //             this._toastr.error('Error', res.message || 'Data not found');
  //             this._loaderService.setLoaderState(false);
  //           }
  //         },
  //         error: (res) => {
  //           this._loaderService.setLoaderState(false);
  //           this._toastr.error('Error', res.message || 'Data not found');
  //         }
  //       });
  //   }
  // }

  // getInventoryPurchaseHeader() {
  //   this._samplepoListingService
  //     .getInventoryPurchaseHeader(this.purchaseOrderNumber)
  //     .subscribe({
  //       next: (res) => {
  //         this.purchaseOrderHeader = res.data?.purchaseOrderHeader;
  //         this.purchaseOrderHeaderAddress =
  //           res.data?.address || ({} as Address);
  //         this.linesGroupForm.patchValue({
  //           lineGroup: this.selectedLineGroup,
  //           site: this.purchaseOrderHeader.siteD365,
  //           warehouse: this.purchaseOrderHeader.warehouseD365,
  //           owner: this.purchaseOrderHeader.ownerD365,
  //           location: this.purchaseOrderHeader.storeD365
  //         });

  //         this.setJobName();
  //         this.setLocation();
  //       },
  //       error: (err) => {
  //         this._loaderService.setLoaderState(false);
  //       }
  //     });
  // }

  getInventoryPurchaseHeader() {
    if (this.saleOrderId) {
      this._loaderService.setLoaderState(true);
      this._samplepoListingService
        .getInventoryPurchaseHeader(this.saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this._loaderService.setLoaderState(false);

              if (
                !this.quickEntyFieldStatus?.includes("Copy Header") &&
                !this.quickEntyFieldStatus?.includes("Copy Line") &&
                !this.quickEntyFieldStatus?.includes("Add Setup") &&
                !this.quickEntyFieldStatus?.includes("Misc")
              ) {
                if (
                  res.data?.address &&
                  !(
                    res.data?.purchaseOrderHeader?.deliveryAddressDescription
                      ?.toLowerCase()
                      .includes("multi") ||
                    res.data?.purchaseOrderHeader?.deliveryAddressDescription
                      ?.toLowerCase()
                      .includes("tbd")
                  )
                ) {
                  this.addressObject = res.data.address as Address;
                  this.shipTo.onDeliveryAddressChange("To Header Ship To");
                  this.shipTo.patchFormInHeaderToShip(this.addressObject);
                  this.shipTo.patchFormDeliveryAddress("To Header Ship To", "");
                } else {
                  const addressSelection =
                    res.data?.purchaseOrderHeader?.deliveryAddressDescription;
                  this.shipTo.patchFormDeliveryAddress(
                    "To Header Ship To",
                    addressSelection || ""
                  );
                }
                if (res.data?.purchaseOrderHeader) {
                  this.headerObject = res.data.purchaseOrderHeader;

                  this.customerId =
                    res.data.purchaseOrderHeader?.clientProspectNumber;
                  this.shipTo.patchFormInHeaderToShipAddress(this.headerObject);
                }
              }

              this.getAllShippingMethod();
              if (
                res.data.purchaseOrderHeader?.deliveryModeIdD365 &&
                !this.orderLineNumber
              ) {
                this.shippingMethod =
                  res.data.purchaseOrderHeader?.deliveryModeIdD365;
                this.patchValueInShippingMethodWithAccountNumber(
                  this.shippingMethod,
                  res.data.purchaseOrderHeader.accountNumber ?? ""
                );
              }

              if (
                this.serviceLineToEdit.id ||
                this.serviceLineToEdit.tempId ||
                this.serviceLineToEdit.portalKeyD365
              ) {
                this.getAddressUsingPostalCode();
              }

              if (this.sellCurrencyStatus) {
                this.lineDetail.getSellCurrency(this.sellCurrency);
              }
              if (res.data.purchaseOrderHeader?.clientProspectNumber) {
                this._orderLineItem
                  .getPartyNumberByAccountNumber(
                    res.data.purchaseOrderHeader.clientProspectNumber
                  )
                  .subscribe(x => {
                    this.patchValueInCustomerAddressField(
                      res.data.purchaseOrderHeader.clientProspectNumber || "",
                      x.data || ""
                    );
                  });
              }

              // for hiding lookup
              this.shipTo.shipTo.showAddress = true;
            } else {
              this._toastr.error("Error", res.message || "Data not found");
              this._loaderService.setLoaderState(false);
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Data not found");
          },
        });
    }
  }

  // checkPOAssignment() {
  //   if (this.saleOrderLine.length > 0) {
  //     const vendorNumber = this.saleOrderItemLine.get([
  //       'vendor',
  //       'vendorDirectDelivery'
  //     ])?.value;
  //     let lineStatus = false;
  //     this.saleOrderLine.forEach((x) => {
  //       if (x.salesOrderLine?.vendorDirectDeliveryD365 === vendorNumber) {
  //         lineStatus = true;
  //       }
  //     });

  //     if (lineStatus) {
  //       this.poAssignment = 'Default';
  //       this.patchValueInPoAssignment(this.poAssignment);
  //     } else {
  //       if (this.isFromCdi) {
  //         this.poAssignment = 'Existing';
  //         this.getVendorDetails(this.linesVendorNumber);
  //         // this.purchaseOrderId = this.poNumber;
  //       } else {
  //         this.poAssignment = 'New';
  //         if (
  //           this.lineActionResult === 'Copy Header' ||
  //           this.lineActionResult === 'Copy Line' ||
  //           this.lineActionResult === 'Add Setup' ||
  //           this.lineActionResult === 'Misc'
  //         ) {
  //           this.poAssignment = 'Default';
  //           this.patchValueInPoAssignment(this.poAssignment);
  //           this.saleOrderItemLine.patchValue({
  //             vendor: {
  //               vendorPoAssignment: 'Default'
  //             }
  //           });
  //         }
  //       }

  //       this.patchValueInPoAssignment(this.poAssignment);
  //     }
  //   }
  // }

  getVendorDetails(vendorLineNumber: string) {
    this.getSourcingVendor(vendorLineNumber);
  }

  getCustomerFinancialDimension(customerAccountNumber: string) {
    this._addNewClientService
      .getCustomerFinancialDimension(customerAccountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.customerFinancialDimension = res.data;
        },
      });
  }

  // patchValueInPoAssignment(poAssigment: string) {
  //   this.saleOrderItemLine.patchValue({
  //     vendor: {
  //       vendorPoAssignment: poAssigment
  //     }
  //   });
  // }

  openSideBarForPoAssignment(event: string) {
    if (event === "Existing") {
      this.displaySidebar = true;
    } else {
      this.displaySidebar = false;
    }
  }

  patchValueInCustomerAddressField(accountNumber: string, partyNumber: string) {
    this.customerBillToObject = {
      partyNumber: partyNumber,
      accountNumber: accountNumber,
    };
    this._customerAccountService
      .getCustomerAddressByPartyNumber(partyNumber, accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const primaryAddress = res.data.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1" ||
              x.rolesD365?.toLowerCase() === "delivery"
          );
          this.customerLists = primaryAddress;
          const currentClientObject = this.customerLists?.filter(
            x =>
              x?.locationNumberD365 ===
                this.currentSaleOrderLine?.locationNumberD365 &&
              x?.addressD365 === this.currentSaleOrderLine?.addressD365
          );
          if (currentClientObject?.length > 0) {
            this.shipTo.patchValueInCustomerShipToName(
              currentClientObject[0]?.descriptionD365 ?? ""
            );
          }
        },
      });
  }

  patchValueInFirm(firm: boolean) {
    this.saleOrderItemLine.patchValue({
      detail: {
        firm: firm,
      },
    });
  }

  onShippingMethodSelect(shippingMethodCode: string) {
    if (!this.orderLineNumber) {
      const index = this.shippingProductsList.findIndex(
        x => x.modeCodeD365 == shippingMethodCode
      );

      if (index > -1) {
        const selectedShippingMethod = this.shippingProductsList[index];
        if (
          selectedShippingMethod.useFreightAccountD365?.toLowerCase() == "yes"
        ) {
          this.saleOrderItemLine.patchValue({
            detail: {
              accountNumberD365: selectedShippingMethod.jniFreightAcctNumD365,
            },
          });
        } else {
          this._orderLineItemDetailService
            .getClientFreightAccountNumber(this.customerId)
            .subscribe({
              next: res => {
                if (res.data) {
                  this.saleOrderItemLine.patchValue({
                    detail: {
                      accountNumberD365: res.data,
                    },
                  });
                }
              },
            });
        }
      }
    }
  }

  patchValueInShippingMethod(shippingMethod: string) {
    this.saleOrderItemLine.patchValue({
      detail: {
        shippingMethod: shippingMethod,
      },
    });
  }

  patchValueInShippingMethodWithAccountNumber(
    shippingMethod: string,
    accountNumber: string
  ) {
    this.saleOrderItemLine.patchValue({
      detail: {
        shippingMethod: shippingMethod,
        accountNumberD365: accountNumber,
      },
    });
  }

  patchValueInShipDate(shipdate: string) {
    this.saleOrderItemLine.patchValue({
      detail: {
        shipDate: shipdate,
      },
    });
  }

  patchValueInHandDate(inhandate: string) {
    this.saleOrderItemLine.patchValue({
      detail: {
        inHandDate: inhandate,
      },
    });
  }

  getLineNumber(saleOrderId: string) {
    return this._orderLineItem.getSaleOrderLineNumber(saleOrderId).subscribe({
      next: x => {
        this.orderItemLineNumber = x.data || 1;
      },
    });
  }

  clearSaleOrderLineForm() {
    this.saleOrderItemLine.patchValue({
      vendor: {
        duplicateVendorDirectDelivery: "",
        vendorDirectDelivery: "",
        // vendorPoAssignment: '',
        vendorName: "",
        vendorAddress: "",
        vendorPhone: "",
        vendorEmail: "",
        vendorFax: "",
      },
      // shipTo: {
      //   deliveryAddress: '',
      //   attention: '',
      //   countryRegionIdD365: '',
      //   zipCodeD365: '',
      //   cityD365: '',
      //   stateD365: '',
      //   addressD365: '',
      //   streetD365: '',
      //   shipToEmail: '',
      //   addressBook: '',
      //   buildingComplimentD365: '',
      //   apartment_RUD365: '',
      //   postBoxD365: '',
      //   countyD365: '',
      //   streetNumberD365: '',
      //   districtNameD365: '',
      //   shipToEmailAddress: '',
      //   addressSelectionName: '',
      //   locationD365: ''
      // },
      detail: {
        firm: false,
      },
      lines: {
        itemNumberD365: "",
        externalItemNumberD365: "",
        orderedPurchaseQuantityD365: "",
        isnetInForeignCurrencyStatus: "",
        purchasePriceD365: 0,
        netTotalD365: 0,
        netConversion: "",
        netConversionTotal: "",
        sell: 0,
        sellTotal: "",
        sellConversion: "",
        sellConversionTotal: "",
        commission: 0,
        grossProfit: 0,
        lineDescriptionD365: "",
        factoryNotes: "",
        currencyCodeD365: "",
        rates: 0,
        size: "",
        color: "",
        config: "",
        style: "",
        categoryName: "",
        excluded: false,
        final: false,
      },
    });
  }

  clearLineData() {
    this.saleOrderItemLine.patchValue({
      lines: {
        itemNumberD365: "",
        externalItemNumberD365: "",
        orderedPurchaseQuantityD365: "",
        isnetInForeignCurrencyStatus: "",
        purchasePriceD365: 0,
        netTotalD365: 0,
        netConversion: "",
        netConversionTotal: "",
        sell: 0,
        sellTotal: "",
        sellConversion: "",
        sellConversionTotal: "",
        commission: 0,
        grossProfit: 0,
        lineDescriptionD365: "",
        factoryNotes: "",
        currencyCodeD365: "",
        rates: 0,
        size: "",
        color: "",
        config: "",
        style: "",
        categoryName: "",
        excluded: false,
        final: false,
      },
    });
  }

  next(lineAction: string) {
    this.submitButtonlogValidationErrors();
    this.lineActionResult = lineAction;
    this._loaderService.setLoaderState(true);

    const saleOrderLineFormObject =
      this.saleOrderItemLine.getRawValue() as SaleOrderItemLine;
    if (saleOrderLineFormObject.lines.orderedPurchaseQuantityD365 === "0") {
      this._toastr.error("Error", "ZERO quantity not allowed for Services");
      this._loaderService.setLoaderState(false);

      return;
    }
    if (lineAction === "Add Setup") {
      this.addSetupIsnetInForeignCurrencyValue =
        saleOrderLineFormObject.lines.isnetInForeignCurrencyStatus;
      this.addSetupNetCurrencyValue =
        saleOrderLineFormObject.lines.currencyCodeD365;
    }

    if (lineAction === "Misc") {
      this.addSetupIsnetInForeignCurrencyValue =
        saleOrderLineFormObject.lines.isnetInForeignCurrencyStatus;
      this.addSetupNetCurrencyValue =
        saleOrderLineFormObject.lines.currencyCodeD365;
    }

    if (
      lineAction === "Copy Header" ||
      lineAction === "Copy Line" ||
      lineAction === "Add Setup" ||
      lineAction === "Misc"
    ) {
      // saleOrderLineFormObject.vendor.vendorPoAssignment = 'Default';
      this.poAssignment = "Default";
      // this.patchValueInPoAssignment(this.poAssignment);
      this.saleOrderItemLine.patchValue({
        vendor: {
          vendorPoAssignment: "Default",
        },
      });
    }
    saleOrderLineFormObject.lines.portalKey = uuidv4();
    const linesArray = [];
    linesArray.push(saleOrderLineFormObject.lines);
    linesArray.forEach(x => {
      if (x.currencyCodeD365 && x.currencyCodeD365 !== "USD") {
        x.isnetInForeignCurrencyStatus = true;
      }
    });

    if (
      saleOrderLineFormObject.detail &&
      !saleOrderLineFormObject.detail.shipDate
    ) {
      // this._loaderService.setLoaderState(false);
      // this._toastr.error('Error', 'Ship date is required');
      // return;
      saleOrderLineFormObject.detail.shipDate = null;
    }

    //if (!saleOrderLineFormObject.detail?.inHandDate) {
    //   this._loaderService.setLoaderState(false);
    //   this._toastr.error('Error', 'Inhand date is required');
    //   return;
    //}

    if (!saleOrderLineFormObject.lines?.itemNumberD365) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Category is required");
      return;
    }

    if (!saleOrderLineFormObject.vendor?.vendorDirectDelivery) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Vendor is Mandatory");
      return;
    }

    if (
      saleOrderLineFormObject.lines?.orderedPurchaseQuantityD365 === "0" ||
      saleOrderLineFormObject.lines?.orderedPurchaseQuantityD365 === null ||
      saleOrderLineFormObject.lines?.orderedPurchaseQuantityD365 ===
        undefined ||
      saleOrderLineFormObject.lines?.orderedPurchaseQuantityD365 === ""
    ) {
      this._toastr.error("Error", "ZERO quantity not allowed for Services");
      this._loaderService.setLoaderState(false);
      return;
    }

    if (
      saleOrderLineFormObject.detail?.shipDate &&
      saleOrderLineFormObject.detail?.inHandDate
    ) {
      if (
        new Date(saleOrderLineFormObject.detail?.inHandDate) <
        new Date(saleOrderLineFormObject.detail?.shipDate)
      ) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date should be greater and equal to ship date"
        );
        return;
      }
    }

    if (
      saleOrderLineFormObject.shipTo &&
      saleOrderLineFormObject.shipTo.addressLocationNumber === 0
    ) {
      saleOrderLineFormObject.shipTo.addressLocationNumber = 0;
    }

    if (
      saleOrderLineFormObject?.shipTo &&
      !saleOrderLineFormObject.shipTo?.addressSelectionName
    ) {
      this._toastr.error("Error", "Ship To Delivery is required");
      this._loaderService.setLoaderState(false);
      return;
    }

    const addressD365 = this.headerObject.deliveryAddressDescription;
    if (
      addressD365 &&
      (saleOrderLineFormObject.shipTo.addressSelectionName
        ?.toLowerCase()
        ?.includes("header") ||
        saleOrderLineFormObject.shipTo.addressSelectionName
          ?.toLowerCase()
          ?.includes("header")) &&
      (addressD365?.toLowerCase()?.includes("multi") ||
        addressD365?.toLowerCase()?.includes("drop") ||
        addressD365?.toLowerCase()?.includes("tbd"))
    ) {
      saleOrderLineFormObject.shipTo.addressD365 = "";
    }

    if (
      !(
        (saleOrderLineFormObject.shipTo?.addressSelectionName ==
          "To Header Ship To" ||
          saleOrderLineFormObject.shipTo?.addressSelectionName ==
            "To header ship to" ||
          saleOrderLineFormObject.shipTo?.addressSelectionName ==
            "To header ship-to") &&
        (this.headerObject.deliveryAddressDescription == "TBD" ||
          this.headerObject.deliveryAddressDescription == "Multiple ship-to" ||
          this.headerObject.deliveryAddressDescription
            ?.toLowerCase()
            .includes("drop") ||
          this.headerObject.deliveryAddressDescription == "Multi Ship To")
      )
    ) {
      if (!saleOrderLineFormObject.shipTo.countryRegionIdD365) {
        this._toastr.error("Error", "Address is required");
        this._loaderService.setLoaderState(false);
        return;
      }
      if (
        !saleOrderLineFormObject.shipTo.zipCodeD365 &&
        saleOrderLineFormObject.shipTo.countryRegionIdD365 === "USA"
      ) {
        this._toastr.error("Error", "Address is required");
        this._loaderService.setLoaderState(false);
        return;
      }
    }

    if (saleOrderLineFormObject.lines.commission === 0) {
      saleOrderLineFormObject.lines.commission = 0;
    }

    if (saleOrderLineFormObject.lines.grossProfit === 0) {
      saleOrderLineFormObject.lines.grossProfit = 0;
    }
    // if (saleOrderLineFormObject['lines'].orderedPurchaseQuantityD365 === 0) {
    //   this._toastr.error('Error', 'Quantity required');
    //   this._loaderService.setLoaderState(false);
    //   return;
    // }

    if (saleOrderLineFormObject.shipTo.attention) {
      saleOrderLineFormObject.lines.attentionInformationD365 =
        saleOrderLineFormObject.shipTo.attention;
    }
    if (saleOrderLineFormObject.shipTo.locationD365) {
      saleOrderLineFormObject.lines.locationD365 =
        saleOrderLineFormObject.shipTo.locationD365;
    }

    const currency = this.saleOrderItemLine.get([
      "lines",
      "currencyCodeD365",
    ])?.value;
    if (currency === "USD") {
      this.saleOrderItemLine.patchValue({
        lines: {
          netConversion: "",
          netConversionTotal: "",
        },
      });
    }

    if (
      saleOrderLineFormObject.shipTo?.addressSelectionName
        ?.toLowerCase()
        .includes("one")
    ) {
      saleOrderLineFormObject.shipTo.addressLocationNumber = 0;
    }

    if (this.serviceLineToEdit.tempId || this.serviceLineToEdit.id >= 0) {
      this.editServiceLineItem(saleOrderLineFormObject);
      if (lineAction === "Add Line") {
        this.addLineAfterCreatingLine();
      } else if (lineAction === "Copy Line") {
        this.copyLineAfterCreatingLine();
      } else if (lineAction === "Add Setup") {
        this.addSetupAfterCreatingLine();
      }
      return;
    }

    const request = this.createServiceLineRequest(saleOrderLineFormObject);

    // if (saleOrderLineRequest.shipTo) {
    //   const formValue = this.saleOrderItemLine.getRawValue();
    //   const value = formValue['shipTo']['shipToVendorAccountNameD365'] || '';
    //   saleOrderLineRequest.shipTo.deliveryAddressD365 =
    //     this.getDeliveryAddress(
    //       saleOrderLineRequest.shipTo.addressSelectionName || '',
    //       saleOrderLineRequest.shipTo.deliveryNameD365 || '',
    //       value || ''
    //     );

    //   saleOrderLineRequest.shipTo.shipToD365Address =
    //     formValue['shipTo']['addressD365'] || '';
    // }

    this.checkCurrencyMismatch(
      request,
      CheckCurrencyMismatchCallingMethod.nextMethodCreateSaleOrderLine,
      lineAction
    );
  }

  addSetupAfterCreatingLine() {
    this.orderLineNumber = "";
    this.lineId = 0;
    this.isEdit = false;
    this.quickEntyFieldStatus = "Add Setup";
    this._toastr.success("Success", "Setup Added Successfully");
    this.getInventoryPurchaseHeader();
    this.clearLineData();
    this.lineDetail.clearLineForm();
    this.lineDetail.disabledNetField();
    this.patchValueInSetup();
  }

  addLineAfterCreatingLine() {
    this.quickEntyFieldStatus = "Add Line";
    this.orderLineNumber = "";
    this.lineId = 0;
    this.isEdit = false;
    this._toastr.success("Success", "Line Added Successfully");

    this.getInventoryPurchaseHeader();
    this.clearSaleOrderLineForm();
    this.lineDetail.clearLineForm();
    this.shipTo.clearShipToAddressForm();
    this.details.clearInHandDateAndShipDate();
    this.lineDetail.disabledNetConversionCurrencyField();
  }

  copyLineAfterCreatingLine() {
    this.orderLineNumber = "";
    this.lineId = 0;
    this.isEdit = false;
    this.quickEntyFieldStatus = "Copy Line";
    this._toastr.success("Success", "Line Copied Successfully");
  }
  unTouchForm() {
    this.saleOrderItemLine.markAsUntouched();
    this.saleOrderItemLine.markAsPristine();
    this.formErrors = {
      duplicateVendorDirectDelivery: "",
      itemNumberD365: "",
      orderedPurchaseQuantityD365: "",
      vendorPoAssignment: "",
      shipDate: "",
      inHandDate: "",
      addressSelectionName: "",
      size: "",
      color: "",
      config: "",
      style: "",
      categoryName: "",
    };
  }

  getAddressUsingPostalCode() {
    this._samplepoListingService
      .getAddressUsingPostalCode(this.serviceLineToEdit.postalAddressD365 ?? 0)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data?.address) {
            this.saleOrderLine = {
              purchaseOrderLine: this.serviceLineToEdit,
              address: res.data.address,
            };
            //this.saleOrderLine = res.data;
            if (this.orderLineNumber) {
              if (this.saleOrderLine?.purchaseOrderLine) {
                this.setModDates(this.saleOrderLine?.purchaseOrderLine);
                // const number =
                //   this.saleOrderLine[0]?.salesOrderLine?.lineNumberD365;
                // this.orderItemLineNumber = number || 1;
                // this.patchSalesClassficationValue(
                //   this.saleOrderLine[0]?.salesOrderLine
                //     ?.salesClassificationIdD365 ?? 0
                // );
                this.selectedItemNumber =
                  this.saleOrderLine.purchaseOrderLine.itemNumberD365 ?? "";
              }
            } else {
              // this.getLineNumber(this.saleOrderId);
            }
            this.patchValueByLineNumber(this.saleOrderLine, this.sellCurrency);
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }

  patchValueInSetup() {
    this.saleOrderItemLine.patchValue({
      lines: {
        itemNumberD365: "Set Up",
        externalItemNumberD365: "SET UP",
        orderedPurchaseQuantityD365: 1,
        lineDescriptionD365: "SET UP",
        factoryNotes: "SET UP",
        currencyCodeD365: this.addSetupNetCurrencyValue,
        isnetInForeignCurrencyStatus: this.addSetupIsnetInForeignCurrencyValue,
      },
    });
    this.currencyFromVendorEvent(this.addSetupNetCurrencyValue);
  }

  patchValueInMisc() {
    this.saleOrderItemLine.patchValue({
      lines: {
        itemNumberD365: "Misc",
        externalItemNumberD365: "Misc",
        orderedPurchaseQuantityD365: 1,
        lineDescriptionD365: "Additional fee related to sell of inventory",
        factoryNotes: "",
        currencyCodeD365: this.addSetupNetCurrencyValue,
        isnetInForeignCurrencyStatus: this.addSetupIsnetInForeignCurrencyValue,
      },
    });
    this.currencyFromVendorEvent(this.addSetupNetCurrencyValue);
  }

  submitButtonlogValidationErrors(
    group: FormGroup = this.saleOrderItemLine
  ): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  onSubmit() {
    this.submitButtonlogValidationErrors();
    this.onSubmitDone = true;

    const saleOrderLineFormObject =
      this.saleOrderItemLine.getRawValue() as SaleOrderItemLine;
    saleOrderLineFormObject.lines.portalKey = uuidv4();
    const linesArray = [];
    linesArray.push(saleOrderLineFormObject.lines);
    linesArray.forEach(x => {
      if (x.currencyCodeD365 && x.currencyCodeD365 !== "USD") {
        x.isnetInForeignCurrencyStatus = true;
      }
    });

    if (
      saleOrderLineFormObject.detail &&
      !saleOrderLineFormObject.detail.shipDate
    ) {
      // this._loaderService.setLoaderState(false);
      // this._toastr.error('Error', 'Ship date is required');
      // return;
      saleOrderLineFormObject.detail.shipDate = null;
    }

    // if (
    //   (!saleOrderLineFormObject['vendor']?.vendorName ||
    //     !saleOrderLineFormObject['vendor']?.vendorDirectDelivery) &&
    //   saleOrderLineFormObject['lines']?.purchasePriceD365
    // ) {
    //   this._loaderService.setLoaderState(false);
    //   this._toastr.error('Error', 'Vendor is required');
    //   return;
    // }

    //if (!saleOrderLineFormObject.detail?.inHandDate) {
    //  this._loaderService.setLoaderState(false);
    //  this._toastr.error('Error', 'Inhand date is required');
    //  return;
    //}

    if (!saleOrderLineFormObject.vendor?.vendorDirectDelivery) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Vendor is Mandatory");
      return;
    }

    if (
      saleOrderLineFormObject.detail?.shipDate &&
      saleOrderLineFormObject.detail?.inHandDate
    ) {
      if (
        new Date(saleOrderLineFormObject.detail?.inHandDate) <
        new Date(saleOrderLineFormObject.detail?.shipDate)
      ) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date should be greater and equal to ship date"
        );
        return;
      }
    }

    if (!saleOrderLineFormObject.lines?.itemNumberD365) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Category is required");
      return;
    }

    if (
      saleOrderLineFormObject.lines.orderedPurchaseQuantityD365 === "0" ||
      saleOrderLineFormObject.lines.orderedPurchaseQuantityD365 === null ||
      saleOrderLineFormObject.lines.orderedPurchaseQuantityD365 === undefined ||
      saleOrderLineFormObject.lines.orderedPurchaseQuantityD365 === ""
    ) {
      this._toastr.error("Error", "ZERO quantity not allowed for Services");
      this._loaderService.setLoaderState(false);
      return;
    }

    this._loaderService.setLoaderState(false);

    if (
      saleOrderLineFormObject.shipTo &&
      saleOrderLineFormObject.shipTo.addressLocationNumber === 0
    ) {
      saleOrderLineFormObject.shipTo.addressLocationNumber = 0;
    }

    if (
      saleOrderLineFormObject?.shipTo &&
      !saleOrderLineFormObject.shipTo?.addressSelectionName
    ) {
      this._toastr.error("Error", "Ship To Delivery is required");
      this._loaderService.setLoaderState(false);
      return;
    }

    const addressD365 = this.headerObject.deliveryAddressDescription;
    if (
      addressD365 &&
      (saleOrderLineFormObject.shipTo.addressSelectionName
        ?.toLowerCase()
        ?.includes("header") ||
        saleOrderLineFormObject.shipTo.addressSelectionName
          ?.toLowerCase()
          ?.includes("header")) &&
      (addressD365?.toLowerCase()?.includes("multi") ||
        addressD365?.toLowerCase()?.toLowerCase().includes("drop") ||
        addressD365?.toLowerCase()?.includes("tbd"))
    ) {
      saleOrderLineFormObject.shipTo.addressD365 = "";
    }

    if (
      !(
        (saleOrderLineFormObject.shipTo?.addressSelectionName ==
          "To Header Ship To" ||
          saleOrderLineFormObject.shipTo?.addressSelectionName ==
            "To header ship to" ||
          saleOrderLineFormObject.shipTo?.addressSelectionName ==
            "To header ship-to") &&
        (this.headerObject.deliveryAddressDescription == "TBD" ||
          this.headerObject.deliveryAddressDescription == "Multiple ship-to" ||
          this.headerObject.deliveryAddressDescription
            ?.toLowerCase()
            .includes("drop") ||
          this.headerObject.deliveryAddressDescription == "Multi Ship To")
      )
    ) {
      if (!saleOrderLineFormObject.shipTo.countryRegionIdD365) {
        this._toastr.error("Error", "Address is required");
        this._loaderService.setLoaderState(false);
        return;
      }

      if (
        !saleOrderLineFormObject.shipTo.zipCodeD365 &&
        saleOrderLineFormObject.shipTo.countryRegionIdD365 === "USA"
      ) {
        this._toastr.error("Error", "Address is required");
        this._loaderService.setLoaderState(false);
        return;
      }
    }

    if (saleOrderLineFormObject.lines.commission === 0) {
      saleOrderLineFormObject.lines.commission = 0;
    }

    if (saleOrderLineFormObject.lines.grossProfit === 0) {
      saleOrderLineFormObject.lines.grossProfit = 0;
    }

    if (saleOrderLineFormObject.lines.orderedPurchaseQuantityD365 === "0") {
      this._toastr.error("Error", "ZERO quantity not allowed for Services");
      this._loaderService.setLoaderState(false);
      return;
    }

    if (saleOrderLineFormObject.shipTo.attention) {
      saleOrderLineFormObject.lines.attentionInformationD365 =
        saleOrderLineFormObject.shipTo.attention;
    }
    if (saleOrderLineFormObject.shipTo.locationD365) {
      saleOrderLineFormObject.lines.locationD365 =
        saleOrderLineFormObject.shipTo.locationD365;
    }

    if (
      this.isMelissaValidationIgnore ||
      this.isCopiedLineMelissaValidationIgnore
    ) {
      this.saleOrderItemLine.get(["shipTo", "streetD365"])?.clearValidators();
      this.saleOrderItemLine
        .get(["shipTo", "streetD365"])
        ?.updateValueAndValidity();
      this.saleOrderItemLine.get(["shipTo", "addressD365"])?.clearValidators();
      this.saleOrderItemLine
        .get(["shipTo", "addressD365"])
        ?.updateValueAndValidity();
      this.saleOrderItemLine.get(["shipTo", "zipCodeD365"])?.clearValidators();
      this.saleOrderItemLine
        .get(["shipTo", "zipCodeD365"])
        ?.updateValueAndValidity();
    }

    if (!this.saleOrderItemLine.valid) {
      this._loaderService.setLoaderState(false);
      return;
    }
    const currency = this.saleOrderItemLine.get([
      "lines",
      "currencyCodeD365",
    ])?.value;
    if (currency === "USD") {
      this.saleOrderItemLine.patchValue({
        lines: {
          netConversion: "",
          netConversionTotal: "",
        },
      });
    }

    this._loaderService.setLoaderState(true);
    if (
      saleOrderLineFormObject.shipTo?.addressSelectionName
        ?.toLowerCase()
        .includes("one")
    ) {
      saleOrderLineFormObject.shipTo.addressLocationNumber = 0;
    }

    if (
      this.serviceLineToEdit.tempId ||
      this.serviceLineToEdit.id ||
      this.serviceLineToEdit.portalKeyD365
    ) {
      this.editServiceLineItem(saleOrderLineFormObject);
      if (this.saleOrderModalStatus) {
        this.closeEvent.emit();
      }
      return;
    }
    const request = this.createServiceLineRequest(saleOrderLineFormObject);

    // if (saleOrderLineRequest.shipTo) {
    //   const formValue = this.saleOrderItemLine.getRawValue();
    //   const value = formValue['shipTo']['shipToVendorAccountNameD365'] || '';
    //   saleOrderLineRequest.shipTo.deliveryAddressD365 = this.getDeliveryAddress(
    //     saleOrderLineRequest.shipTo.addressSelectionName || '',
    //     saleOrderLineRequest.shipTo.deliveryNameD365 || '',
    //     value || ''
    //   );

    //   saleOrderLineRequest.shipTo.shipToD365Address =
    //     formValue['shipTo']['addressD365'] || '';
    // }
    this.checkCurrencyMismatch(
      request,
      CheckCurrencyMismatchCallingMethod.onSubmitMethodCreateSaleOrderLine,
      ""
    );
  }

  editServiceLineItem(saleOrderLineFormObject: SaleOrderItemLine) {
    const purchaseOrderLine: PurchaseOrderLine[] = [];
    const line = {
      deliverySelectionD365:
        saleOrderLineFormObject.shipTo?.addressSelectionName,
      shipToTypeD365: saleOrderLineFormObject.shipTo?.addressLocationNumber,
      postalAddressD365: saleOrderLineFormObject.shipTo?.addressLocationNumber,
      shipToAddressD365: saleOrderLineFormObject.shipTo?.addressD365,
      deliveryNameD365: saleOrderLineFormObject.shipTo?.deliveryNameD365,
      addressDescriptionD365: saleOrderLineFormObject.shipTo?.deliveryNameD365,
      lineGroupD365: this.lineGroup,
      id: this.serviceLineToEdit.tempId ? 0 : this.serviceLineToEdit.id,
      portalKeyD365: saleOrderLineFormObject.lines?.portalKey,
      lineRecIdD365: null,
      siteD365: this.site,
      warehouseD365: this.warehouse,
      jobNameD365: this.parent.get("jobName")?.value,
      wMSLocationD365: this.parent.get("location")?.value,
      parentD365: false,
      purchaseOrderNumberD365: this.saleOrderId,
      purchaseUnitSymbolD365: "ea",
      vendorIdD365: saleOrderLineFormObject.vendor?.vendorDirectDelivery,
      vendorNameD365: saleOrderLineFormObject.vendor?.vendorName,
      deliveryModeIdD365: saleOrderLineFormObject.detail?.shippingMethod,
      freightAccountNumD365: saleOrderLineFormObject.detail?.accountNumberD365,
      itemNumberD365: saleOrderLineFormObject.lines?.itemNumberD365,
      externalItemNumberD365:
        saleOrderLineFormObject.lines?.externalItemNumberD365,
      descriptionD365: saleOrderLineFormObject.lines?.lineDescriptionD365,
      lineDescriptionD365: saleOrderLineFormObject.lines?.lineDescriptionD365,
      factoryNotesD365: saleOrderLineFormObject.lines?.factoryNotes,
      currencyCodeD365: saleOrderLineFormObject.lines?.currencyCodeD365,
      requestedDeliveryDateD365: saleOrderLineFormObject.detail?.inHandDate,
      requestedShippingDateD365: saleOrderLineFormObject.detail?.shipDate,
      rsmFirmD365: saleOrderLineFormObject.detail?.firm ? "yes" : "no",
      finalPoD365: saleOrderLineFormObject.lines?.final,
      excludedD365: saleOrderLineFormObject.lines?.excluded,
      orderedPurchaseQuantityD365:
        saleOrderLineFormObject.lines?.orderedPurchaseQuantityD365 &&
        saleOrderLineFormObject.lines?.orderedPurchaseQuantityD365 !== ""
          ? saleOrderLineFormObject.lines?.orderedPurchaseQuantityD365
          : 0,
      purchasePriceD365: saleOrderLineFormObject.lines?.purchasePriceD365,
      lineAmountD365: saleOrderLineFormObject.lines?.netTotalD365,
      netConversion: saleOrderLineFormObject.lines?.netConversion,
      netConversionTotal: saleOrderLineFormObject.lines?.netConversionTotal,
      priceInTransactionCurrency:
        saleOrderLineFormObject.lines?.priceInTransactionCurrency,
      amountInTransactionCurrency:
        saleOrderLineFormObject.lines?.amountInTransactionCurrency,
      tempId: this.serviceLineToEdit.tempId,
    } as unknown as PurchaseOrderLine;

    //purchaseOrderLine.push(line);

    this._loaderService.setLoaderState(false);
    this._toastr.success(`Line Edited Successfully`, "Success");
    this.editedServiceLine.emit([line]);
    // if (this.saleOrderModalStatus) {
    //   this.closeEvent.emit();
    // }
    return purchaseOrderLine;
  }

  showPositionDialogDescription(
    position:
      | "center"
      | "top"
      | "bottom"
      | "left"
      | "right"
      | "topleft"
      | "topright"
      | "bottomleft"
      | "bottomright"
  ) {
    this.position = position;
    this.displayPositionDescription = true;
    this.stockPhraseDescription.flag = "description";
    this.stockPhraseDescription.selectedStock = [];
    this.stockPhraseDescription.getStockPhraseData();
  }

  showPositionDialogFactory(
    position:
      | "center"
      | "top"
      | "bottom"
      | "left"
      | "right"
      | "topleft"
      | "topright"
      | "bottomleft"
      | "bottomright"
  ) {
    this.position = position;
    this.displayPositionFactory = true;
    this.stockPhraseFactory.flag = "factory";
    this.stockPhraseFactory.selectedStock = [];
    this.stockPhraseFactory.getStockPhraseData();
  }

  getDeliveryAddress(
    addressSelectionName: string,
    deliveryNameD365: string,
    shipToVendorAccountNameD365: string
  ) {
    if (addressSelectionName.toLowerCase().includes("one")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("bill")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("vendor")) {
      return shipToVendorAccountNameD365;
    } else if (addressSelectionName.toLowerCase().includes("address")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("branding")) {
      return deliveryNameD365;
    }
    return "";
  }

  createServiceLineRequest(
    saleOrderLineFormObject: SaleOrderItemLine
  ): PurchaseOrderLine[] {
    const purchaseOrderLine: PurchaseOrderLine[] = [];
    const line = {
      deliverySelectionD365:
        saleOrderLineFormObject.shipTo?.addressSelectionName,
      shipToTypeD365: saleOrderLineFormObject.shipTo?.addressLocationNumber,
      postalAddressD365: saleOrderLineFormObject.shipTo?.addressLocationNumber,
      shipToAddressD365: saleOrderLineFormObject.shipTo?.addressD365,
      deliveryNameD365: saleOrderLineFormObject.shipTo?.deliveryNameD365,
      addressDescriptionD365: saleOrderLineFormObject.shipTo?.deliveryNameD365,
      lineGroupD365: this.lineGroup,
      id: 0,
      portalKeyD365: saleOrderLineFormObject.lines.portalKey,
      lineRecIdD365: null,
      siteD365: this.site,
      warehouseD365: this.warehouse,
      jobNameD365: this.parent.get("jobName")?.value,
      wMSLocationD365: this.parent.get("location")?.value,
      parentD365: false,
      purchaseOrderNumberD365: this.saleOrderId,
      purchaseUnitSymbolD365: "ea",
      vendorIdD365: saleOrderLineFormObject.vendor?.vendorDirectDelivery,
      vendorNameD365: saleOrderLineFormObject.vendor?.vendorName,
      deliveryModeIdD365: saleOrderLineFormObject.detail?.shippingMethod,
      freightAccountNumD365: saleOrderLineFormObject.detail?.accountNumberD365,
      itemNumberD365: saleOrderLineFormObject.lines?.itemNumberD365,
      externalItemNumberD365:
        saleOrderLineFormObject.lines?.externalItemNumberD365,
      descriptionD365: saleOrderLineFormObject.lines?.lineDescriptionD365,
      lineDescriptionD365: saleOrderLineFormObject.lines?.lineDescriptionD365,
      factoryNotesD365: saleOrderLineFormObject.lines?.factoryNotes,
      currencyCodeD365: saleOrderLineFormObject.lines?.currencyCodeD365,
      requestedDeliveryDateD365: saleOrderLineFormObject.detail?.inHandDate,
      requestedShippingDateD365: saleOrderLineFormObject.detail?.shipDate,
      rsmFirmD365: saleOrderLineFormObject.detail?.firm ? "yes" : "no",
      finalPoD365: saleOrderLineFormObject.lines?.final,
      excludedD365: saleOrderLineFormObject.lines?.excluded,
      orderedPurchaseQuantityD365:
        saleOrderLineFormObject.lines?.orderedPurchaseQuantityD365 &&
        saleOrderLineFormObject.lines?.orderedPurchaseQuantityD365 !== ""
          ? saleOrderLineFormObject.lines?.orderedPurchaseQuantityD365
          : 0,
      purchasePriceD365: saleOrderLineFormObject.lines?.purchasePriceD365,
      lineAmountD365: saleOrderLineFormObject.lines?.netTotalD365,
      netConversion: saleOrderLineFormObject.lines?.netConversion,
      netConversionTotal: saleOrderLineFormObject.lines?.netConversionTotal,
      priceInTransactionCurrency:
        saleOrderLineFormObject.lines?.priceInTransactionCurrency,
      amountInTransactionCurrency:
        saleOrderLineFormObject.lines?.amountInTransactionCurrency,
    } as unknown as PurchaseOrderLine;

    if (this.createFinishedGoodTemplate) {
      line.tempId = purchaseOrderLine.length + 1;
    }

    purchaseOrderLine.push(line);
    return purchaseOrderLine;
  }

  closePositionDialogDescription() {
    this.displayPositionDescription = false;
  }

  closePositionDialogFactory() {
    this.displayPositionFactory = false;
  }

  getDescription(event: StockPhrase[]) {
    let description = "";
    event.forEach(element => {
      if (element.description) {
        if (description == "") {
          description += element.description;
        } else {
          description += "\n" + element.description;
        }
      }
    });

    let orderLineDescription = "";

    if (description) {
      orderLineDescription = `${
        this.saleOrderItemLine.get(["lines", "lineDescriptionD365"])?.value ||
        ""
      }\n${description}`;
    } else {
      orderLineDescription = `${
        this.saleOrderItemLine.get(["lines", "lineDescriptionD365"])?.value ||
        ""
      }`;
    }

    this.saleOrderItemLine.patchValue({
      lines: {
        lineDescriptionD365: orderLineDescription,
      },
    });
    this.closePositionDialogDescription();
  }

  getFactory(event: StockPhrase[]) {
    let fact = "";
    event.forEach(element => {
      if (element.notes) {
        if (fact == "") {
          fact += element.notes;
        } else {
          fact += "\n" + element.notes;
        }
      }
    });

    let orderLineFactoryNotes = "";

    if (fact) {
      orderLineFactoryNotes = `${
        this.saleOrderItemLine.get(["lines", "factoryNotes"])?.value || ""
      }\n${fact}`;
    } else {
      orderLineFactoryNotes = `${
        this.saleOrderItemLine.get(["lines", "factoryNotes"])?.value || ""
      }`;
    }

    this.saleOrderItemLine.patchValue({
      lines: {
        factoryNotes: orderLineFactoryNotes,
      },
    });
    this.closePositionDialogFactory();
  }

  addPurchaseOrderObject(event: string) {
    this.purchaseOrderId = event;
    this.displaySidebar = false;
    this.onSubmit();
  }

  getLoaderStatus() {
    //this.showSmallLoader = status;
  }

  collapseStatus = false;
  expandStatus = true;
  collapseHeading = "Collapse all";

  getStateOfCollapseAll() {
    const status = localStorage.getItem("sale-order-line-collapse");
    if (status) {
      if (status === "true") {
        this.collapseStatus = true;
        this.expandStatus = false;
        this.collapseHeading = "Expand all";
      } else {
        this.collapseStatus = false;
        this.expandStatus = true;
        this.collapseHeading = "Collapse all";
      }
    }
  }

  onToggle() {
    if (this.expandStatus) {
      this.collapseStatus = true;
      this.expandStatus = false;
      // this.setStateOfExpandAll();
      this.collapseHeading = "Expand all";
    } else {
      this.collapseStatus = false;
      this.expandStatus = true;
      // this.setStateOfCollapseAll();
      this.collapseHeading = "Collapse all";
    }
  }

  setStateOfExpandAll() {
    localStorage.setItem("sale-order-line-collapse", "true");
  }

  setStateOfCollapseAll() {
    localStorage.setItem("sale-order-line-collapse", "false");
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userObject = res.data;
          this.getSalesOrderCommissionBc(res.data.personnelNumber);
        }
      },
    });
  }

  getSalesOrderCommissionBc(userPersonnelNumber: string) {
    this._orderSummaryService
      .getSalesOrderCommissionBc(this.saleOrderId)
      .subscribe({
        next: async res => {
          if (res?.data) {
            const ifFind = res.data.findIndex(
              x => x.employeeIDD365 == userPersonnelNumber
            );

            if (ifFind != -1 || this.userObject.userRoleId === UserRole.Admin) {
              this.showCommissionsFields = true;
            } else {
              this.showCommissionsFields = false;
            }
          } else {
            this.showCommissionsFields = false;
          }
        },
      });
  }

  openViewPoNumberPdfScreen(purchaseOrderId: string, salesOrderIdD365: string) {
    const url = `/orders/po-email/${salesOrderIdD365}/${purchaseOrderId}`;
    window.open(url, "_blank");
  }

  setModDates(salesOrderLine: PurchaseOrderLine | null) {
    if (salesOrderLine) {
      this.createdDate = salesOrderLine.createdDate ?? "";
      const createdByList = salesOrderLine.createdBy?.split("@") ?? [];
      if (createdByList && createdByList.length > 1) {
        this.createdBy = createdByList[0] || "";
      }
      const modifiedByList = salesOrderLine.lastModifiedBy?.split("@") ?? [];
      if (modifiedByList && modifiedByList.length > 1) {
        this.modifiedBy = modifiedByList[0] ?? "";
      }
      this.modifiedDate = salesOrderLine.lastModifiedDate ?? "";
    }
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  redirectToCopiedFrom() {
    if (this.saleOrderLineHistory?.lineCopiedFrom) {
      if (
        this.saleOrderLineHistory?.lineCopiedFrom === EnumCopiedFrom.IsFromOrder
      ) {
        const url = `/orders/order-summary/${this.saleOrderLineHistory.lineCopiedFromHeaderId}`;
        window.open(url, "_blank");
      } else if (
        this.saleOrderLineHistory?.lineCopiedFrom === EnumCopiedFrom.IsFromQuote
      ) {
        const url = `/proposal/quote-summary/${this.saleOrderLineHistory.lineCopiedFromHeaderId}`;
        window.open(url, "_blank");
      }
    }
  }

  setCopiedFromInfo() {
    let copiedInfo = "";

    if (this.saleOrderLineHistory?.lineCopiedFromPurchaseOrderD365) {
      copiedInfo =
        " PO " +
        this.saleOrderLineHistory?.lineCopiedFromPurchaseOrderD365 +
        "   Line " +
        this.saleOrderLineHistory?.lineCopiedFromLineNumberD365 +
        "   ";
    } else if (this.saleOrderLineHistory?.lineCopiedFromHeaderId) {
      if (
        this.saleOrderLineHistory.lineCopiedFrom === EnumCopiedFrom.IsFromOrder
      ) {
        copiedInfo =
          " Ord " +
          this.saleOrderLineHistory?.lineCopiedFromHeaderId +
          "   Line " +
          this.saleOrderLineHistory?.lineCopiedFromLineNumberD365 +
          "   ";
      } else if (
        this.saleOrderLineHistory.lineCopiedFrom === EnumCopiedFrom.IsFromQuote
      ) {
        copiedInfo =
          " Proposal " +
          this.saleOrderLineHistory?.lineCopiedFromHeaderId +
          "   Line " +
          this.saleOrderLineHistory?.lineCopiedFromLineNumberD365 +
          "   ";
      }
    }
    return copiedInfo;
  }

  checkCurrencyMismatch(
    saleOrderLineRequest: PurchaseOrderLine[] | UpdateSalesOrderLineDto,
    callFromMethod: string,
    lineAction: string
  ) {
    // if (
    //   saleOrderLineRequest &&
    //   saleOrderLineRequest?.vendor &&
    //   (saleOrderLineRequest?.vendor?.vendorPoAssignment === 'Default' ||
    //     saleOrderLineRequest?.vendor?.vendorPoAssignment === 'Existing')
    // ) {
    //   if (saleOrderLineRequest?.lines) {
    //     const checkCurrencyMismatchRequest: CheckCurrencyMismatchRequestDto = {
    //       currencyCode: saleOrderLineRequest?.lines[0]?.currencyCodeD365,
    //       purchaseOrderId: saleOrderLineRequest?.purchaseOrderId || '',
    //       salesOrderId: saleOrderLineRequest?.saleOrderId || '',
    //       vendorDirectDelivery:
    //         saleOrderLineRequest?.vendor?.vendorDirectDelivery || '',
    //       vendorPoAssignment:
    //         saleOrderLineRequest?.vendor?.vendorPoAssignment || '',
    //       isnetInForeignCurrencyStatus:
    //         saleOrderLineRequest?.lines[0]?.isnetInForeignCurrencyStatus
    //     };
    //     this._loaderService.setLoaderState(true);
    //     this._orderLineItem
    //       .checkCurrencyMismatch(checkCurrencyMismatchRequest)
    //       .pipe(untilDestroyed(this))
    //       .subscribe({
    //         next: (res) => {
    //           this._loaderService.setLoaderState(false);
    //           if (res.status.toLowerCase() == 'success') {
    //             if (res?.data && res?.data?.isMismatch === true) {
    //               this._toastr.error(
    //                 'Error',
    //                 res.message || 'Currency must be the same'
    //               );
    //             } else {
    //               if (
    //                 callFromMethod ===
    //                 CheckCurrencyMismatchCallingMethod.onSubmitMethodCreateSaleOrderLine
    //               ) {
    //                 this.onSubmitMethodcreateSalesOrderLine(
    //                   saleOrderLineRequest
    //                 );
    //               } else if (
    //                 callFromMethod ===
    //                 CheckCurrencyMismatchCallingMethod.onSubmitMethodUpdateSaleOrderLine
    //               ) {
    //                 this.onSubmitMethodUpdateSalesOrderLine(
    //                   saleOrderLineRequest
    //                 );
    //               } else if (
    //                 callFromMethod ===
    //                 CheckCurrencyMismatchCallingMethod.nextMethodCreateSaleOrderLine
    //               ) {
    //                 this.nextMethodCreateSaleOrderLine(
    //                   saleOrderLineRequest,
    //                   lineAction
    //                 );
    //               } else if (
    //                 callFromMethod ===
    //                 CheckCurrencyMismatchCallingMethod.nextMethodUpdateSaleOrderLine
    //               ) {
    //                 this.nextMethodUpdateSaleOrderLine(saleOrderLineRequest);
    //               }
    //             }
    //           }
    //         },
    //         error: (res) => {
    //           this._loaderService.setLoaderState(false);
    //           this._toastr.error(
    //             'Error',
    //             res.message || 'Error checking the currecny validation'
    //           );
    //         }
    //       });
    //   }
    // } else {
    if (
      callFromMethod ===
      CheckCurrencyMismatchCallingMethod.onSubmitMethodCreateSaleOrderLine
    ) {
      this.onSubmitMethodcreateSalesOrderLine(
        saleOrderLineRequest as PurchaseOrderLine[]
      );
    } else if (
      callFromMethod ===
      CheckCurrencyMismatchCallingMethod.onSubmitMethodUpdateSaleOrderLine
    ) {
      this.onSubmitMethodUpdateSalesOrderLine();
    } else if (
      callFromMethod ===
      CheckCurrencyMismatchCallingMethod.nextMethodCreateSaleOrderLine
    ) {
      this.nextMethodCreateSaleOrderLine(
        saleOrderLineRequest as PurchaseOrderLine[],
        lineAction
      );
    } else if (
      callFromMethod ===
      CheckCurrencyMismatchCallingMethod.nextMethodUpdateSaleOrderLine
    ) {
      if (Array.isArray(saleOrderLineRequest)) {
        return;
      }
      this.nextMethodUpdateSaleOrderLine(
        saleOrderLineRequest as UpdateSalesOrderLineDto
      );
    }
    // }
  }

  onSubmitMethodcreateSalesOrderLine(lines: PurchaseOrderLine[]) {
    this._loaderService.setLoaderState(false);
    this._toastr.success(`Line Created Successfully`, "Success");
    this.linesForTemplate.emit(lines);
    if (this.saleOrderModalStatus) {
      this.closeEvent.emit();
    }
    // this._loaderService.setLoaderState(true);
    // this._samplepoListingService.addLineGroup(lines).subscribe({
    //   next: (res) => {
    //     this._loaderService.setLoaderState(false);

    //     this._toastr.error(res.message, 'Error');
    //   },
    //   error: (err) => {
    //     this._loaderService.setLoaderState(false);
    //   }
    // });
  }

  onSubmitMethodUpdateSalesOrderLine() {
    if (!this.isEdit || this.onSubmitDone) {
      // this._loaderService.setLoaderState(true);
      const isQuantityValid = this.isQuantityValid();
      if (!isQuantityValid) {
        return;
      }

      // TBD
      this.linesForTemplate.emit();
      this._toastr.success("Success", "Line Added Successfully");
      if (this.saleOrderModalStatus) {
        this.closeEvent.emit();
        return;
      }
    }
  }

  nextMethodCreateSaleOrderLine(
    lines: PurchaseOrderLine[],
    lineAction: string
  ) {
    if (!this.isEdit || this.onSubmitDone) {
      this.linesForTemplate.emit(lines);
      this._loaderService.setLoaderState(false);
      if (lineAction === "Add Line") {
        this.quickEntyFieldStatus = "Add Line";
        this.orderLineNumber = "";
        this.lineId = 0;
        this.isEdit = false;
        this._toastr.success("Success", "Line Added Successfully");
        this.serviceLineToEdit = {} as PurchaseOrderLine;
        this.getInventoryPurchaseHeader();
        this.clearSaleOrderLineForm();
        this.lineDetail.clearLineForm();
        this.shipTo.clearShipToAddressForm();
        this.details.clearInHandDateAndShipDate();
        this.lineDetail.disabledNetConversionCurrencyField();
      } else if (lineAction === "Copy Header") {
        this.orderLineNumber = "";
        this.lineId = 0;
        this.isEdit = false;
        this.quickEntyFieldStatus = "Copy Header";
        this.getInventoryPurchaseHeader();
        this.clearLineData();
        this.lineDetail.clearLineForm();
        this.lineDetail.disabledNetField();
      } else if (lineAction === "Copy Line") {
        this.orderLineNumber = "";
        this.lineId = 0;
        this.isEdit = false;
        this.quickEntyFieldStatus = "Copy Line";
        this._toastr.success("Success", "Line Copied Successfully");
        //this.getInventoryPurchaseHeader();
      } else if (lineAction === "Add Setup") {
        this.orderLineNumber = "";
        this.lineId = 0;
        this.isEdit = false;
        this.serviceLineToEdit = {} as PurchaseOrderLine;
        this.quickEntyFieldStatus = "Add Setup";
        this._toastr.success("Success", "Setup Added Successfully");
        this.getInventoryPurchaseHeader();
        this.clearLineData();
        this.lineDetail.clearLineForm();
        this.lineDetail.disabledNetField();
        this.patchValueInSetup();
      } else if (lineAction === "Misc") {
        this.orderLineNumber = "";
        this.lineId = 0;
        this.isEdit = false;
        this.quickEntyFieldStatus = "Misc";
        this.getInventoryPurchaseHeader();
        this.clearLineData();
        this.lineDetail.clearLineForm();
        this.lineDetail.disabledNetField();
        this.patchValueInMisc();
      }
      this.unTouchForm();
    } else {
      if (lineAction === "Add Line") {
        this.quickEntyFieldStatus = "Add Line";
        this.orderLineNumber = "";
        this.lineId = 0;
        this.isEdit = false;
        this._toastr.success("Success", "Line Added Successfully");

        this.getInventoryPurchaseHeader();
        this.clearSaleOrderLineForm();
        this.lineDetail.clearLineForm();
        this.shipTo.clearShipToAddressForm();
        this.details.clearInHandDateAndShipDate();
        this.lineDetail.disabledNetConversionCurrencyField();
      } else if (lineAction === "Copy Header") {
        this.orderLineNumber = "";
        this.lineId = 0;
        this.isEdit = false;
        this.quickEntyFieldStatus = "Copy Header";
        this.getInventoryPurchaseHeader();
        this.clearLineData();
        this.lineDetail.clearLineForm();
        this.lineDetail.disabledNetField();
        this.saveToPortal = true;
      } else if (lineAction === "Copy Line") {
        this.orderLineNumber = "";
        this.lineId = 0;
        this.isEdit = false;
        this.quickEntyFieldStatus = "Copy Line";
        this._toastr.success("Success", "Line Copied Successfully");

        //this.getInventoryPurchaseHeader();
        this.saveToPortal = true;
      } else if (lineAction === "Add Setup") {
        this.orderLineNumber = "";
        this.lineId = 0;
        this.isEdit = false;
        this.quickEntyFieldStatus = "Add Setup";
        this.getInventoryPurchaseHeader();
        this.clearLineData();
        this.lineDetail.clearLineForm();
        this.lineDetail.disabledNetField();
        this.patchValueInSetup();
        this._toastr.success("Success", "Setup Added Successfully");

        this.saveToPortal = true;
      } else if (lineAction === "Misc") {
        this.orderLineNumber = "";
        this.lineId = 0;
        this.isEdit = false;
        this.quickEntyFieldStatus = "Misc";
        this.getInventoryPurchaseHeader();
        this.clearLineData();
        this.lineDetail.clearLineForm();
        this.lineDetail.disabledNetField();
        this.patchValueInMisc();
        this.saveToPortal = true;
        this.lineGridRefresh.emit();
      }
      this.unTouchForm();
    }
  }

  nextMethodUpdateSaleOrderLine(saleOrderLineRequest: UpdateSalesOrderLineDto) {
    // TBD for update
    // this._loaderService.setLoaderState(true);
    if (!this.isEdit || this.onSubmitDone) {
      const isQuantityValid = this.isQuantityValid();
      if (!isQuantityValid) {
        return;
      }
      this._orderLineItem
        .updateSaleOrderLine(saleOrderLineRequest)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this._toastr.success(
                "Success",
                res.message || "Line Item Updated Successfully"
              );

              if (res.data) {
                this.clearSaleOrderLineForm();
                this.lineDetail.clearLineForm();
                this.shipTo.clearShipToAddressForm();
                this.details.clearInHandDateAndShipDate();
                this.lineDetail.disabledNetConversionCurrencyField();
                this.unTouchForm();
                if (this.orderLineNumber) {
                  if (res?.data?.salesOrderLines) {
                    const saleOrderLineList =
                      res?.data?.salesOrderLines.lineNumberD365;
                    this.orderItemLineNumber = saleOrderLineList || 1;
                  }
                  if (this.saleOrderModalStatus) {
                    this.getLineNumber(this.saleOrderId);
                    this.orderLineNumber = "";
                    this.lineId = 0;
                    this.getInventoryPurchaseHeader();
                    return;
                  }
                  this.route.navigate([
                    "/orders/order-line-item/" + this.saleOrderId,
                  ]);
                } else {
                  this.getLineNumber(this.saleOrderId);
                  this.getInventoryPurchaseHeader();
                }
              }
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error Updating Line Item"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error Updating Line Item"
            );
          },
        });
    }
  }

  checkShowHideFields() {
    if (this.lineStatusD365?.toLowerCase() === "delivered") {
      this.disabledEnabledFormFieldForDelivered();
    }

    if (this.lineStatusD365?.toLowerCase() === "open order") {
      // Check if its the partial line Task:11400
      if (this.deliverRemainderD365 > this.orderedPurchaseQuantityD365) {
        this.disabledEnabledFormFieldForPartiallyDeliveredLines();
        setTimeout(() => {
          this.netFieldStatus = true;
        }, 2000);
        this.disabledQuantityField();
      }
    }
  }

  disabledEnabledFormFieldForPartiallyDeliveredLines() {
    this.saleOrderItemLine
      .get(["vendor", "duplicateVendorDirectDelivery"])
      ?.disable();
    this.saleOrderItemLine.get(["vendor", "vendorPoAssignment"])?.disable();

    this.saleOrderItemLine.get(["lines", "factoryNotes"])?.disable();
    this.saleOrderItemLine.get(["lines", "itemNumberD365"])?.disable();
    this.saleOrderItemLine.get(["lines", "externalItemNumberD365"])?.disable();
    this.saleOrderItemLine.get(["lines", "currencyCodeD365"])?.disable();
    this.saleOrderItemLine
      .get(["lines", "isnetInForeignCurrencyStatus"])
      ?.disable();

    this.saleOrderItemLine.get(["detail", "shippingMethod"])?.disable();
    this.saleOrderItemLine.get(["detail", "accountNumberD365"])?.disable();
    this.saleOrderItemLine.get(["detail", "firm"])?.disable();
    this.saleOrderItemLine.get(["detail", "shipDate"])?.disable();
    this.saleOrderItemLine.get(["detail", "inHandDate"])?.disable();

    this.saleOrderItemLine.get(["shipTo", "addressSelectionName"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "deliveryNameD365"])?.disable();
    this.saleOrderItemLine
      .get(["shipTo", "attentionInformationD365"])
      ?.disable();
    this.saleOrderItemLine.get(["shipTo", "addressD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "countryRegionIdD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "attention"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "locationD365"])?.disable();
    this.saleOrderItemLine.get(["shipTo", "rSMJNIShipToEmailD365"])?.disable();
    this.saleOrderItemLine
      .get(["shipTo", "shipToVendorAccountNameD365"])
      ?.disable();
    this.saleOrderItemLine.get(["shipTo", "addressFormat"])?.disable();

    this.saleOrderItemLine.get(["lines", "sell"])?.enable();
    this.saleOrderItemLine.get(["lines", "lineDescriptionD365"])?.enable();
    this.sellRateValueWithIconStatus = false; // to make it sell field enable

    this.netFieldStatus = true;

    this.clientShipToAddressDisabled = true;
    this.vendorNameShipToAddressDisabled = true;
  }

  currencyFromVendorEvent(currecny: string) {
    if (!currecny) {
      currecny = "USD";
    }

    if (currecny !== "USD") {
      this.lineDetail.onCurrencyEnable("checked");
    }
    this.saleOrderItemLine.patchValue({
      lines: {
        currencyCodeD365: currecny,
      },
    });
    this.lineDetail.onCurrencyConversion();
  }

  isQuantityValid() {
    if (this.salesOrderLine?.purchaseOrderLineStatusD365) {
      if (
        this.salesOrderLine.purchaseOrderLineStatusD365.toLowerCase() ===
        "delivered"
      ) {
        // if (
        //   this.salesOrderLine.deliverRemainderD365 &&
        //   this.salesOrderLine.deliverRemainderD365 !== 0 &&
        //   this.salesOrderLine.orderedPurchaseQuantityD365
        // ) {
        //   const matchedValue =
        //     this.salesOrderLine.orderedPurchaseQuantityD365 -
        //     this.salesOrderLine.deliverRemainderD365;
        //   if (Number($event) < matchedValue) {
        //     this._loaderService.setLoaderState(false);
        //     this._toastr.error(
        //       'Error',
        //       'The QTY cannot be less than the matched qty.'
        //     );
        //     return false;
        //   }
        // }
        // if (
        //   this.salesOrderLine.deliverRemainderD365 === 0 &&
        //   (this.salesOrderLine.orderedPurchaseQuantityD365 ?? 0) >
        //     Number($event)
        // ) {
        //   this._loaderService.setLoaderState(false);
        //   this._toastr.error(
        //     'Error',
        //     'The QTY cannot be less than the matched qty.'
        //   );
        //   return false;
        // }
      }
    }
    return true;
  }

  showHideButtons(proposalIdD365: string) {
    if (proposalIdD365 && proposalIdD365 != "") {
      this.isLineProposalExist = true;
    } else {
      this.isLineProposalExist = false;
    }
  }

  isMelissaValidationIgnoreEvent(value: boolean) {
    this.isMelissaValidationIgnore = value;
  }

  isMelissaAddressValidatedEvent(value: boolean) {
    if (value == true) {
      this.isCopiedLineMelissaValidationIgnore = false;
      this.isMelissaValidationIgnore = false;
    }
  }

  onSaleOrderNotesSave() {
    if (this.saleOrderId) {
      const obj: SalesOrderNotes = {
        salesOrderId: this.saleOrderId,
        portalKey: uuidv4(),
        description: "System Order # " + this.saleOrderId,
        id: 0,
        note: "Non approved address was accepted",
        purchaseOrderStatus: false,
        type: "Order note",
        purchaseOrderId: "",
        createdDate: "",
        createdBy: "",
        lastModifiedDate: null,
        lastModifiedBy: null,
        isActive: false,
      };

      this._orderNotesSidebarService
        .AddSalesOrderNotes(obj)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: () => {
            // Console.log('nothing to do so far');
          },
        });
    }
  }

  closeModal() {
    this.closeEvent.emit();
  }
}
